import React, { useMemo, useState, useEffect, useLayoutEffect, useRef, useCallback } from 'react'
import { Input, Button, Select, FormItem, FormContainer, Notification, toast, Upload, DatePicker, Spinner, Checkbox, Tooltip, Radio } from 'components/ui'
import { Field, Form, Formik, useFormikContext } from 'formik'
import { HiCheck, HiOutlineSearch, HiOutlineFilter, HiX, HiOutlineUser } from 'react-icons/hi'
import { components } from 'react-select'
import { useSelector, useDispatch } from 'react-redux'
import * as Yup from 'yup'
import { createArrayWithItemId, formatterInputSelectData, isMobile, jsonToFormData,  orderByStoreName, renameFile, storeActive } from 'utils/storeHube/helpers'
import { RichTextEditor, UsersAvatarGroup, StoreTagFilter } from 'components/shared'
import SelectedStoresSummary from './SelectedStoresSummary'
import { apiGetUserStores, apiGetAllUsers, apiPostAnswerTicket, apiPostTicket, apiTicketExpiration } from 'services/TicketsService'
import { apiFetchStores } from 'services/StoreService'
import { getTickets } from '../store/dataSlice'
import { statusResponse } from 'constants/apiResponse.constant'
import { useTranslation } from 'react-i18next'
import i18n from 'i18next'
import { FcImageFile } from 'react-icons/fc'
import { apiGetStoreById } from 'services/StoreService'
import usePermissions from 'utils/hooks/usePermissions'
import { toggleTicketDialog } from '../store/stateSlice'
import dayjs from 'dayjs'
import { apiGetTicketsCategoriesById } from 'services/TicketCategoryTypeServices'
import QuestionGenerator from './QuestionGenerator'
import QuestionnaireWrapper from 'views/tickets/components/QuestionnaireWrapper'
import { filterVisibleQuestions } from 'views/crud/formQuetionsGroup/helpers'
import { resolverVisibles, idsQueSeOcultan, claveDeId } from 'views/tickets/utils/conditionalQuestions'
import PreguntasExigidasWatcher from 'views/tickets/components/PreguntasExigidasWatcher'
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'
import { getDescriptionImages } from './ImageResizer'
import { TEXT, SELECTOR, CHECKBOX, RADIO, TEXTAREA, DATE, MENU, FILE, TITLE, AI_VISUAL_CHECK, NUMBER, OBJECT, STRING } from 'constants/app.constant'
import AddTicketSchedule from './AddTicketSchedule'
import { resetValuesForTicket } from '../store/globalSlice'
import { apiPostTicketSchedule } from 'services/TicketScheduleService'
import handleTicketError from '../utils/handleTicketError'
import { setTicketScheduleList } from 'views/ticketSchedule/store/dataSlice'
import { injectReducer } from 'store'
import ticketScheduleReducer from "../../ticketSchedule/store/index"
import { secondsToMinutes, formatDateInput } from 'utils/storeHube/helpersDate'
import { useNavigate } from 'react-router-dom'
import { deleteKey, getKey, setKey } from 'utils/storeHube/localStorage'
import { fetchTicketStores, fetchTicketStoreTags, setStoreFilters } from '../store/globalSlice'
import { computeStoreListHeight, STORE_LIST_MAX_HEIGHT, STORE_LIST_BOTTOM_GAP } from './storeListHeight'


const { DateTimepicker } = DatePicker
const { Control } = components

injectReducer('ticketSchedule', ticketScheduleReducer)

const DEFAULT_RECURRENCE = 'daily'

const RESPONSIBLE_ROLES = ['managements', 'technicians', 'analysts', 'marketing', 'store_managers']

// Un array vacio (CHECKBOX sin nada tildado, FILE sin archivos) no cuenta como respondida.
const estaRespondida = (valor) => {
    if (valor === null || valor === undefined || valor === '') return false
    if (Array.isArray(valor)) return valor.length > 0
    return true
}

const isResponsibleOption = (data) => typeof data?.value === 'string' && RESPONSIBLE_ROLES.includes(data.value)

const getOperatorId = (option) => isResponsibleOption(option) ? option.value : option.id

const buildResponsibleParams = (hasResponsible, { page, pageSize }) =>
    hasResponsible
        ? { all: true, 'filter[has_responsible]': hasResponsible, 'filter[visible]': true }
        : { page, pageSize }

// Maps role value to the store props key
const getRolePropKey = (role) => role

const ResponsibleIcon = ({ className = '' }) => (
    <span className={`flex items-center justify-center w-7 h-7 min-w-[1.75rem] rounded-full bg-indigo-100 dark:bg-indigo-500/30 text-indigo-600 dark:text-indigo-300 flex-shrink-0 ${className}`}>
        <HiOutlineUser className="text-sm" />
    </span>
)

const CustomSelectOption = ({ innerProps, label, data, isSelected }) => {

    return (
        <div
            className={`flex items-center justify-between p-2 cursor-pointer ${isSelected ? 'bg-gray-100 dark:bg-gray-500' : 'hover:bg-gray-50 dark:hover:bg-gray-600'}`}
            {...innerProps}
        >
            <div className="flex items-center">
                {isResponsibleOption(data) ? (
                    <ResponsibleIcon />
                ) : (
                    <UsersAvatarGroup
                        avatarProps={{ className: 'mr-1 rtl:ml-1 cursor-pointer' }}
                        avatarGroupProps={{ maxCount: 1 }}
                        chained={false}
                        users={[data]}
                        size={10}
                    />
                )}
                <div className="ml-2 rtl:mr-2">
                    <p className="font-semibold">{label}</p>
                    {data.userName && <p className="text-xs opacity-70">{data.userName}</p>}
                </div>
            </div>
            {isSelected && <HiCheck className="text-emerald-500 text-xl" />}
        </div>
    )
}

const CustomControl = ({ children, ...props }) => {
    const selected = props.getValue()[0]
    return (

        <Control {...props}>
            {selected && (
                isResponsibleOption(selected) ? (
                    <ResponsibleIcon className="ml-2" />
                ) : (
                    <UsersAvatarGroup
                        avatarProps={{ className: 'mr-1 ml-2 rtl:ml-1 cursor-pointer' }}
                        avatarGroupProps={{ maxCount: 1 }}
                        chained={false}
                        users={[selected]}
                    />
                )
            )}
            {children}
        </Control>
    )
}


const SLA_VALUES = [
    { value: 0, key: 'undefined' },
    { value: 60, key: 'hour', count: 1 },
    { value: 120, key: 'hours', count: 2 },
    { value: 240, key: 'hours', count: 4 },
    { value: 300, key: 'hours', count: 5 },
    { value: 360, key: 'hours', count: 6 },
    { value: 540, key: 'hours', count: 9 },
    { value: 600, key: 'hours', count: 10 },
    { value: 720, key: 'hours', count: 12 },
    { value: 1440, key: 'days', count: 1 },
    { value: 2880, key: 'days', count: 2 },
    { value: 4320, key: 'days', count: 3 },
    { value: 7200, key: 'days', count: 5 },
    { value: 10080, key: 'days', count: 7 },
    { value: 14400, key: 'days', count: 10 },
    { value: 28800, key: 'days', count: 20 },
    { value: 43200, key: 'days', count: 30 },
]

const CustomSelectOptionSubcategory = ({ innerProps, label, data, isSelected }) => {

    const { t } = useTranslation()

    function findSlaOptionByValue(valueToFind) {
        const entry = SLA_VALUES.find(opt => opt.value === valueToFind) ?? SLA_VALUES[0];
        return entry.key === 'undefined' ? t('undefined', { defaultValue: 'Sin definir' }) : `${entry.count} ${t(entry.key)}`
    }
    return (
        <div
            className={`flex items-center justify-between p-2 cursor-pointer ${isSelected ? 'bg-gray-100 dark:bg-gray-500' : 'hover:bg-gray-50 dark:hover:bg-gray-600'}`}
            {...innerProps}
        >
            <div className="flex items-center">
                {/*     <UsersAvatarGroup
                    avatarProps={{ className: 'mr-1 rtl:ml-1 cursor-pointer' }}
                    avatarGroupProps={{ maxCount: 1 }}
                    chained={false}
                    users={[data]}
                    size={10}
                /> */}
                {data.description ?
                    <Tooltip title={data.description} /* placement="bottom" */>
                        <p className="ml-2 rtl:mr-2 cursor-pointer">{label}</p>
                        <p className="ml-2 rtl:mr-2 cursor-pointer font-semibold ">{`Sla: ${findSlaOptionByValue(data.sla)}`}</p>
                    </Tooltip> :
                    <>
                        <span className="ml-2 rtl:mr-2 cursor-pointer">{` ${label}`}</span>
                        <p className="ml-2 rtl:mr-2 cursor-pointer font-semibold">{`Sla: ${findSlaOptionByValue(data.sla)}`}</p>
                    </>
                }
            </div>
            {isSelected && <HiCheck className="text-emerald-500 text-xl" />}
        </div>
    )
}

const CustomControlSubcategory = ({ children, ...props }) => {

    return (

        <Control {...props}>
            {children}
        </Control>
    )
}

const CustomMenuList = ({ children, ...props }) => {
    const { selectProps } = props
    const isLoadingMore = selectProps.isLoadingMore
    const hasOptions = React.Children.count(children) > 0
    const alias = i18n.t('stores_alias', { defaultValue: 'tiendas' })

    return (
        <components.MenuList {...props}>
            {children}
            {isLoadingMore && hasOptions && (
                <div className="flex flex-col items-center gap-2 py-3 border-t border-gray-100 dark:border-gray-600">
                    <Spinner size="sm" />
                    <span className="text-sm text-gray-500 dark:text-gray-300">
                        {i18n.t('loading_stores', { defaultValue: `Cargando ${alias.toLowerCase()}...` })}
                    </span>
                </div>
            )}
        </components.MenuList>
    )
}

const hasNonEmptyValue = (value) => {
    if (value === null || value === undefined) {
        return false
    }
    if (value instanceof Date) {
        return true
    }
    if (typeof value === 'string') {
        return value.trim() !== ''
    }
    if (typeof value === 'number') {
        return true
    }
    if (typeof value === 'boolean') {
        return value
    }
    if (Array.isArray(value)) {
        return value.length > 0
    }
    if (typeof value === 'object') {
        if ('id' in value) {
            return value.id !== undefined && value.id !== null && `${value.id}` !== ''
        }
        if ('value' in value) {
            const val = value.value
            return val !== undefined && val !== null && `${val}`.trim() !== ''
        }
        return Object.values(value).some(hasNonEmptyValue)
    }
    return false
}

const ScrollToError = ({ customErrorTargets = {} }) => {
    const { submitCount, isValid, errors, values } = useFormikContext()

    useEffect(() => {
        if (submitCount > 0 && !isValid) {
            const errorKeys = Object.keys(errors)
            if (!errorKeys.length) {
                return
            }

            const candidates = errorKeys
                .map((key) => {
                    const customTargetRef = customErrorTargets[key]
                    if (customTargetRef?.current) {
                        const target = customTargetRef.current
                        const rect = target.getBoundingClientRect()
                        const position = rect.top + window.pageYOffset
                        return { target, position }
                    }

                    const selectors = [
                        `[data-error-field="${key}"]`,
                        `[name="${key}"]`,
                    ]

                    let element = null
                    for (const selector of selectors) {
                        const match = document.querySelector(selector)
                        if (match) {
                            element = match
                            break
                        }
                    }

                    if (!element) {
                        const fallback = Array.from(document.querySelectorAll('.form-item.invalid'))
                            .find(item => item?.dataset?.errorField === key)
                        element = fallback || null
                    }

                    const target = element?.closest?.('.form-item') || element
                    if (!target) {
                        return null
                    }

                    const rect = target.getBoundingClientRect()
                    const position = rect.top + window.pageYOffset
                    return { target, position }
                })
                .filter(Boolean)

            if (!candidates.length) {
                return
            }

            const firstCandidate = candidates.reduce((prev, current) => (
                current.position < prev.position ? current : prev
            ))

            const formItem = firstCandidate.target

            if (formItem) {
                const scrollableParent = formItem.closest('.overflow-y-auto, .overflow-auto, [style*="overflow"]')
                if (scrollableParent) {
                    const containerRect = scrollableParent.getBoundingClientRect()
                    const itemRect = formItem.getBoundingClientRect()
                    const offset = itemRect.top - containerRect.top + scrollableParent.scrollTop - 20
                    scrollableParent.scrollTo({ top: Math.max(0, offset), behavior: 'smooth' })
                } else if (typeof formItem.scrollIntoView === 'function') {
                    formItem.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
                } else {
                    const yOffset = -100
                    const y = formItem.getBoundingClientRect().top + window.pageYOffset + yOffset
                    window.scrollTo({ top: y, behavior: 'smooth' })
                }
            }
        }
    }, [submitCount, isValid, errors, customErrorTargets])

    return null
}

const SubmittingWatcher = ({ onSubmittingChange }) => {
    const { isSubmitting } = useFormikContext()
    useEffect(() => {
        onSubmittingChange?.(isSubmitting)
    }, [isSubmitting, onSubmittingChange])
    return null
}


const DirtyWatcher = ({ onDirtyChange, externalDirty }) => {
    const { values, initialValues } = useFormikContext()

    const hasFormInput = useMemo(() => {
        if (!values) {
            return false
        }

        return Object.keys(values).some((key) => {
            const currentValue = values[key]
            const initialValue = initialValues?.[key]

            if (!hasNonEmptyValue(currentValue)) {
                return false
            }

            return !isEqual(currentValue, initialValue)
        })
    }, [values, initialValues])

    useEffect(() => {
        onDirtyChange?.(hasFormInput || externalDirty)
    }, [hasFormInput, externalDirty, onDirtyChange])

    return null
}

const AddTicket = ({ onSubmittingChange, showTicketScheduleForm, onDirtyChange, onResponsibleChange }) => {


    const { t } = useTranslation()
    const { checkPermission } = usePermissions()
    const dispatch = useDispatch()
    const tableData = useSelector(state => state.ticketList.data.tableData)

    const QUESTION_PRIMARY_KEY = `question_group_primary`

    const [loadingStores, setLoadingStores] = useState(false)
    const [loadingTicketExpiration, setLoadingTicketExpiration] = useState(false)
    const [ticketUsers, setTicketUsers] = useState([])
    const {
        loadingGlobalTicket,
        ticketParentCategories,
        ticketSubCategories,
        storeTags,
        storeFilters,
        storeTagsLoading,
        storeForTicket,
        parentIdForTicket,
        deviceForTicket,
        recordForTicket,
        addTicketFromCameras,
        secondsForTicket,
    } = useSelector(state => state.ticketList.global)
    const { records} = useSelector(store => store.camerasStoreData.data)
    const { mainRecord, secondsRecord } = records
    const { ticketScheduleList } = useSelector(state => state.ticketSchedule.data)

    const [ticketExpiredAt, setTicketExpiredAt] = useState(null)
    const [categoriesOptions, setCategoriesOptions] = useState([])
    const [files, setFiles] = useState([])
    const [ticketCategoryById, setTicketCategoryById] = useState(null)
    const [questionGroup, setQuestionGroup] = useState(null)
    const [questionGroupId, setQuestionGroupId] = useState(null)
    const [questionLoading, setQuestionLoading] = useState(false)
    // Ids de las preguntas que estaban a la vista en el ultimo intento de envio:
    // las unicas que muestran su error. Ver `PreguntasExigidasWatcher`.
    const [idsExigidos, setIdsExigidos] = useState(() => new Set())
    const [answers, setAnswer] = useState([])
    const [multiTicktes, setTicketsMultiple] = useState(false)
    const [dataUsersAndStores, setDataUsersAndStores] = useState([])
    const [usersMultipleTickets, setUsersMultipleTicktes] = useState([])
    const [userMultipleTicketsId, setUsersMultipleTicktesId] = useState("")
    const [storeAvailableRoles, setStoreAvailableRoles] = useState([])
    const [storeResponsableMap, setStoreResponsableMap] = useState({})
    const [showCategoryFields, setShowCategoryFields] = useState(false)
    const [showStoreFields, setShowStoreFields] = useState(false)
    const [multiStores, setMultiStores] = useState([])
    const [checkedAllStores, setCheckedAllStores] = useState(false)
    const [searchResults, setSearchResults] = useState([]);
    const [storeListOpen, setStoreListOpen] = useState(true)
    const [loadingTeams, setLoadingTeams] = useState(false)
    const [tempSelectedTags, setTempSelectedTags] = useState([])
    const [tagFilterHasFocus, setTagFilterHasFocus] = useState(false)
    const [storeSearchInput, setStoreSearchInput] = useState('')
    const [isSearching, setIsSearching] = useState(false)

    // Paso 1: Estado refactorizado para modo "una tienda"
    const [singleStoresState, setSingleStoresState] = useState({
        items: [],
        pagination: {
            page: 1,
            perPage: 100,
            lastPage: 1,
            total: 0,
            hasMore: false,
            nextPage: null,
            loading: true,
        },
        filters: { tags: [], name: '' },
    })

    // Paso 1: Estado refactorizado para modo "varias tiendas"
    const [multiStoresState, setMultiStoresState] = useState({
        baseItems: [],  // Tiendas base del usuario/operador
        filteredItems: [], // Tiendas después de aplicar tags
        pagination: {
            page: 1,
            perPage: 100,
            lastPage: 1,
            total: 0,
            hasMore: false,
            nextPage: null,
            loading: false,
        },
        loading: false,
        filters: { tags: [], name: '' },
        hasResponsible: '',
    })
    const storeAliasLabel = t('store_alias', { defaultValue: 'tienda' }).toLowerCase()
    const storeManagerLabel = t('store_manager_alias', { storeAlias: storeAliasLabel, defaultValue: t('store_manager') })
    const assignResponsible = useMemo(() => [
        { value: 'managements', label: t("management_support") },
        { value: 'technicians', label: t("technical_support") },
        { value: 'analysts', label: t("analytical_manager") },
        { value: 'marketing', label: t("marketing_support") },
        { value: 'store_managers', label: storeManagerLabel },
    ], [storeManagerLabel, t])

    const operatorGroupedOptions = useMemo(() => [
        { label: t('responsibles', { defaultValue: 'Responsables' }), options: assignResponsible },
        { label: t('users', { defaultValue: 'Usuarios' }), options: usersMultipleTickets },
    ], [assignResponsible, usersMultipleTickets, t])

    const singleOperatorGroupedOptions = useMemo(() => {
        const filteredResponsibles = assignResponsible
            .filter(r => storeAvailableRoles.includes(r.value))
            .map(r => {
                const roleUsers = storeResponsableMap[r.value]
                if (!roleUsers?.length) return r
                const user = ticketUsers.find(u => roleUsers.some(ru => ru.id === u.id)) || roleUsers[0]
                const name = user?.name ? `${user.name} ${user.lastname || ''}`.trim() : null
                return name ? { ...r, userName: name } : r
            })
        const groups = [
            { label: t('users', { defaultValue: 'Usuarios' }), options: ticketUsers },
        ]
        if (filteredResponsibles.length > 0) {
            groups.unshift({ label: t('responsibles', { defaultValue: 'Responsables' }), options: filteredResponsibles })
        }
        return groups
    }, [assignResponsible, ticketUsers, storeAvailableRoles, storeResponsableMap, t])

    const singleStoreLoading = singleStoresState.pagination.loading
    const singleStoreInitialLoading = singleStoreLoading && singleStoresState.items.length === 0
    // Solo deshabilitar controles durante la carga inicial, no durante paginación
    const disableStoreControls = loadingTeams || singleStoreInitialLoading
    const formikRef = useRef(null)
    const scheduleSectionRef = useRef(null)
    const lastToggledIndexRef = useRef(null)

    // Paso 1: RequestId para cancelar fetches obsoletos
    const requestIdRef = useRef(0)
    // Paso 1: Cache simple para resultado inicial (page 1)
    const initialCacheRef = useRef(new Map())


    const navigate = useNavigate()
    const ticket_schedule_can_store = checkPermission("ticket_schedule.can_store")

    const search_expiration_date = !showTicketScheduleForm
    const search_question_group = !showTicketScheduleForm


    const getUsers = (array) => {
        return array.map(obj => obj.user);
    }

    const previousScheduleStateRef = useRef(showTicketScheduleForm)

    useEffect(() => {
        const previousValue = previousScheduleStateRef.current

        if (previousValue !== showTicketScheduleForm) {
            setInitialValuesForm(prev => {
                if (showTicketScheduleForm) {
                    return {
                        ...prev,
                        recurrence: DEFAULT_RECURRENCE,
                        title: null,
                        start_time: '',
                        end_time: '',
                    }
                }

                const { recurrence, title, start_time, end_time, ...rest } = prev
                return rest
            })

            if (formikRef.current) {
                const currentRecurrence = formikRef.current.values?.recurrence
                const nextRecurrence = showTicketScheduleForm ? (currentRecurrence || DEFAULT_RECURRENCE) : ''
                formikRef.current.setFieldValue('recurrence', nextRecurrence, false)
                formikRef.current.setFieldValue('title', null, false)
                formikRef.current.setFieldValue('start_time', '', false)
                formikRef.current.setFieldValue('end_time', '', false)
                formikRef.current.setFieldTouched('recurrence', false, false)
                formikRef.current.setFieldTouched('title', false, false)
                formikRef.current.setFieldTouched('start_time', false, false)
                formikRef.current.setFieldTouched('end_time', false, false)
            }

            previousScheduleStateRef.current = showTicketScheduleForm
        }

        if (showTicketScheduleForm && !previousValue) {
            requestAnimationFrame(() => {
                scheduleSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
            })
        }
    }, [showTicketScheduleForm])


    const getUserById = useCallback((array, id) => {
        const user = array.find(obj => obj.user.id === id)
        return user ? user.stores ?? [] : []
    }, [])

        
    useEffect(() => {
        if (!multiTicktes) {
            return
        }

        if (usersMultipleTickets.length > 0) {
            setLoadingTeams(false)
            return
        }

        setLoadingTeams(true)
        apiGetAllUsers()
            .then((res) => {
                const users = res.data.data.map(user => ({
                    value: user.id,
                    label: `${user.name} ${user.lastname || ''}`.trim(),
                    id: user.id,
                    ...user
                }))
                setUsersMultipleTicktes(users)
            })
            .catch((error) => {
                console.error('Error fetching users', error)
                toast.push(
                    <Notification title={t('error')} type="danger" duration={4000}>
                        {t('fetchUsersError', { defaultValue: 'No se pudieron cargar los usuarios.' })}
                    </Notification>
                )
            })
            .finally(() => setLoadingTeams(false))
    }, [multiTicktes, t, usersMultipleTickets.length])

    const tagFilterCacheRef = useRef(new Map())

    const fetchStoreIdsByTags = useCallback(async (tagIds = []) => {
        const ids = new Set()
        if (!Array.isArray(tagIds) || tagIds.length === 0) {
            return ids
        }

        const sortedKey = [...tagIds].map(String).sort().join(',')
        if (tagFilterCacheRef.current.has(sortedKey)) {
            return new Set(tagFilterCacheRef.current.get(sortedKey))
        }

        let page = 1
        const pageSize = 500
        let hasMore = true
        const collected = new Set()

        while (hasMore) {
            const response = await apiFetchStores({
                page,
                pageSize,
                sort: 'name',
                tags: tagIds,
                tagMode: 'all',
            })

            const payload = response.data ?? {}
            const items = Array.isArray(payload) ? payload : payload.data ?? []

            items.forEach(store => {
                if (store?.id !== undefined && store?.id !== null) {
                    collected.add(Number(store.id))
                }
            })

            const meta = payload.meta ?? {}
            const currentPage = meta.current_page ?? page
            const lastPage = meta.last_page ?? currentPage

            if (!items.length || !meta || currentPage >= lastPage) {
                hasMore = false
            } else {
                page = currentPage + 1
            }
        }

        tagFilterCacheRef.current.set(sortedKey, Array.from(collected))

        return collected
    }, [])

    useEffect(() => {
        if (!userMultipleTicketsId) {
            setMultiStoresState(prev => ({ ...prev, baseItems: [], filteredItems: [] }))
            setCheckedAllStores(false)
            setSearchResults([])
            if (searchInput.current) {
                searchInput.current.value = ''
            }
            return
        }

        setStoreListOpen(false)

        const userStores = getUserById(dataUsersAndStores, userMultipleTicketsId) || []

        const applyStores = (storesToUse = []) => {
            const formattedStores = modifyAndSortArray(storesToUse)
            const selectedIds = new Set(multiStoresRef.current.map(store => store.id))

            const nextStores = formattedStores.map(store => ({
                ...store,
                checked: selectedIds.has(store.id),
            }))

            setMultiStoresState(prev => ({ ...prev, baseItems: nextStores, filteredItems: nextStores }))

            setMultiStores(prev => {
                const allowedIds = new Set(nextStores.map(store => store.id))
                const filtered = prev.filter(store => allowedIds.has(store.id))
                if (filtered.length === prev.length && filtered.every((store, index) => store.id === prev[index].id)) {
                    return prev
                }
                return filtered
            })

            setCheckedAllStores(nextStores.length > 0 && nextStores.every(store => store.checked))

            // Limpiar búsqueda cuando se aplican filtros de etiquetas
            setSearchResults([])
            if (searchInput.current) {
                searchInput.current.value = ''
            }

            setStoreListOpen(true)
        }

        const tagIds = storeFilters?.tags ?? []

        if (!tagIds.length) {
            applyStores(userStores)
            return
        }

        let isActive = true

        const load = async () => {
            try {
                const matchingIds = await fetchStoreIdsByTags(tagIds)
                if (!isActive) {
                    return
                }
                const filteredStores = userStores.filter(store => matchingIds.has(Number(store.id)))
                applyStores(filteredStores)
            } catch (error) {
                if (isActive) {
                    console.error('Error filtering stores by tags', error)
                    toast.push(
                        <Notification title={t('error')} type="danger" duration={4000}>
                            {t('filterStoresByTagsError', { defaultValue: 'No se pudieron filtrar las tiendas por etiquetas. Intenta nuevamente.' })}
                        </Notification>
                    )
                    applyStores([])
                }
            }
        }

        load()

        return () => {
            isActive = false
        }
    }, [userMultipleTicketsId, dataUsersAndStores, storeFilters?.tags, fetchStoreIdsByTags])

    const setCategoryTicket = (parentId) => {
        const list = ticketSubCategories.filter(s => s?.parent_id === parentId)
        setCategoriesOptions(list)
    }

    // Paso 1: Usar estado refactorizado para el ticket dialog
    const stores = useMemo(() => storeActive(orderByStoreName(formatterInputSelectData(singleStoresState.items))), [singleStoresState.items])
    const multiStoresRef = useRef(multiStores)
    const multiStoresStateRef = useRef(multiStoresState)
    const selectedSummaryRef = useRef(null)
    const summaryScrollTriggeredRef = useRef(false)
    const summaryScrollPendingRef = useRef(false)
    const storeListRef = useRef(null)
    const [storeListMaxHeight, setStoreListMaxHeight] = useState(null)
    const multiStoreSectionRef = useRef(null)
    const storeTagsRequestedRef = useRef(false)
    const searchInput = useRef()
    const multiStoreSearchAbortRef = useRef(null)

    const handleMultiStoreSearch = useCallback(async (query) => {
        if (!query || query.trim().length < 2) {
            setSearchResults([])
            return
        }

        // Cancelar búsqueda anterior
        if (multiStoreSearchAbortRef.current) {
            multiStoreSearchAbortRef.current.abort()
        }
        multiStoreSearchAbortRef.current = new AbortController()

        try {
            const tagIds = storeFilters?.tags ?? []
            const currentHasResponsible = multiStoresStateRef.current.hasResponsible
            const response = await apiFetchStores({
                ...buildResponsibleParams(currentHasResponsible, { page: 1, pageSize: 500 }),
                sort: 'name',
                tags: tagIds,
                tagMode: 'all',
                search: query.trim(),
            })

            const storesResponse = response.data ?? {}
            const storeData = Array.isArray(storesResponse) ? storesResponse : storesResponse.data ?? []

            let visibleStores = storeData.filter(store => store.visible === 1)

            // Si hay usuario seleccionado (no responsable), filtrar por sus tiendas
            if (userMultipleTicketsId) {
                const userStores = getUserById(dataUsersAndStores, userMultipleTicketsId) || []
                const userStoreIds = new Set(userStores.map(store => Number(store.id)))
                visibleStores = visibleStores.filter(store => userStoreIds.has(Number(store.id)))
            }

            const filteredStores = visibleStores
                .map(store => {
                    const isChecked = multiStoresRef.current.some(s => Number(s.id) === Number(store.id))
                    return {
                        ...store,
                        label: store.name,
                        value: store.id,
                        checked: isChecked
                    }
                })
                .sort((a, b) => a.label.localeCompare(b.label))

            setSearchResults(filteredStores)
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error searching stores:', error)
                // Fallback a búsqueda local
                const lowercaseQuery = query.toLowerCase()
                const result = multiStoresState.filteredItems.filter(store => {
                    const data = JSON.stringify(store).toLowerCase()
                    return data.includes(lowercaseQuery)
                })
                setSearchResults(result)
            }
        }
    }, [storeFilters?.tags, dataUsersAndStores, userMultipleTicketsId, multiStoresState.filteredItems])

    const handleDebounceFn = useMemo(() => debounce(handleMultiStoreSearch, 500), [handleMultiStoreSearch])

    useEffect(() => {
        multiStoresRef.current = multiStores
    }, [multiStores])

    useEffect(() => {
        multiStoresStateRef.current = multiStoresState
    }, [multiStoresState])

    // Revela el resumen de seleccionadas la primera vez que se elige una tienda.
    // El scroll NUNCA se hace mientras el puntero está sobre la lista: mover la lista
    // bajo el cursor hace que el siguiente click caiga en otra fila. Si el usuario está
    // seleccionando, queda pendiente y se ejecuta cuando saca el mouse de la lista.
    const revealSelectedSummary = useCallback(() => {
        const summaryElement = selectedSummaryRef.current
        if (!summaryElement) {
            return
        }

        const scroller = summaryElement.closest('.base-modal-content')
        const rect = summaryElement.getBoundingClientRect()

        // La visibilidad se mide contra el área visible del modal, no contra la ventana:
        // el modal recorta su contenido mucho antes que el borde del viewport.
        const bounds = scroller
            ? scroller.getBoundingClientRect()
            : { top: 0, bottom: window.innerHeight }

        if (rect.top >= bounds.top && rect.bottom <= bounds.bottom) {
            return
        }

        summaryElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
        })
    }, [])

    useEffect(() => {
        if (multiStores.length === 0) {
            summaryScrollTriggeredRef.current = false
            summaryScrollPendingRef.current = false
            return
        }

        if (summaryScrollTriggeredRef.current) {
            return
        }

        summaryScrollTriggeredRef.current = true

        if (storeListRef.current?.matches(':hover')) {
            summaryScrollPendingRef.current = true
            return
        }

        revealSelectedSummary()
    }, [multiStores.length, revealSelectedSummary])

    const handleStoreListMouseLeave = useCallback(() => {
        if (!summaryScrollPendingRef.current) {
            return
        }
        summaryScrollPendingRef.current = false
        revealSelectedSummary()
    }, [revealSelectedSummary])

    // Sincronizar multiStores con Formik para validación
    useEffect(() => {
        if (multiTicktes && formikRef.current) {
            // Si no hay tiendas seleccionadas, setear como string vacío para que falle la validación
            // Si hay tiendas, setear el array para que pase la validación
            const value = multiStores.length > 0 ? multiStores : ""
            formikRef.current.setFieldValue('store_id', value, false)
        }
    }, [multiStores, multiTicktes])

    // Controlar la visibilidad de campos de categoría
    useEffect(() => {
        // En modo múltiples tareas, siempre mostrar los campos
        if (multiTicktes) {
            setShowCategoryFields(true)
            setShowStoreFields(true)
            return
        }

        // En modo normal, mostrar solo si hay tienda y operador
        if (formikRef.current) {
            const hasStoreAndOperator = (formikRef.current.values.store_id || multiStores.length > 0) && formikRef.current.values.operator_id
            if (hasStoreAndOperator) {
                setShowCategoryFields(true)
            }
        }
    }, [formikRef.current?.values.store_id, formikRef.current?.values.operator_id, multiStores, multiTicktes])

    const ticketPluralAlias = useMemo(() => {
        const alias = t('tickets_alias', { defaultValue: t('tickets') })
        return typeof alias === 'string' ? alias.toLowerCase() : ''
    }, [t])
    const multipleTicketsLabel = useMemo(() => t('multiple_tickets', { alias: ticketPluralAlias }), [t, ticketPluralAlias])
    const canRenderStoreTags = Array.isArray(storeTags) && storeTags.length > 0
    const appliedTagIds = useMemo(() => (
        multiTicktes
            ? (multiStoresState.filters?.tags ?? [])
            : (singleStoresState.filters?.tags ?? [])
    ), [multiTicktes, multiStoresState.filters?.tags, singleStoresState.filters?.tags])

    const selectedTagObjects = useMemo(() => {
        if (!canRenderStoreTags || !appliedTagIds.length) {
            return []
        }
        const map = new Map(
            storeTags.map(tag => [String(tag.id), tag])
        )
        return appliedTagIds
            .map(tagId => map.get(String(tagId)))
            .filter(Boolean)
    }, [appliedTagIds, canRenderStoreTags, storeTags])

    const filterLabelContent = useMemo(() => {
        if (appliedTagIds.length > 0) {
            return (
                <>
                    <span className="text-sm font-semibold">Filtros</span>
                    <span className="inline-flex items-center justify-center h-6 min-w-[1.5rem] rounded-full bg-blue-500/20 dark:bg-blue-400/20 text-blue-700 dark:text-blue-200 font-semibold text-xs px-2.5">
                        {appliedTagIds.length}
                    </span>
                </>
            )
        }
        return <span className="text-sm font-semibold">Filtros</span>
    }, [appliedTagIds.length])

    const filterWidthClass = useMemo(() => {
        if (tagFilterHasFocus) {
            return 'md:w-40 lg:w-48'
        }
        if (appliedTagIds.length > 0) {
            return 'md:w-32 lg:w-44'
        }
        return 'md:w-24 lg:w-32'
    }, [appliedTagIds.length, tagFilterHasFocus])

    const hasAppliedTags = selectedTagObjects.length > 0

    // La lista de tiendas se adapta al alto que queda libre dentro del modal. Con un alto
    // fijo, en pantallas bajas las últimas filas caen por debajo del área visible y quedan
    // tapadas por el footer: ahí no llega ni el click ni la rueda.
    const adjustStoreListHeight = useCallback(() => {
        const listElement = storeListRef.current
        if (!listElement) {
            return
        }

        const scroller = listElement.closest('.base-modal-content')
        if (!scroller) {
            return
        }

        // Alto del contenido que está por encima de la lista, medido dentro del scroller
        // (independiente de cuánto scrolleó el usuario).
        const above = (listElement.getBoundingClientRect().top - scroller.getBoundingClientRect().top) + scroller.scrollTop
        const available = scroller.clientHeight - above - STORE_LIST_BOTTOM_GAP

        setStoreListMaxHeight(computeStoreListHeight(available))
    }, [])

    useLayoutEffect(() => {
        if (!multiTicktes) {
            return undefined
        }

        adjustStoreListHeight()
        window.addEventListener('resize', adjustStoreListHeight)
        return () => window.removeEventListener('resize', adjustStoreListHeight)
    }, [
        adjustStoreListHeight,
        multiTicktes,
        multiStores.length,
        multiStoresState.filteredItems.length,
        searchResults.length,
        hasAppliedTags,
    ])

    useEffect(() => {
        addTicketFromCameras && getStoreUsers(storeForTicket.id)
    }, [])

    const customErrorTargets = useMemo(() => ({
        store_id: multiStoreSectionRef,
    }), [multiStoreSectionRef])

    useEffect(() => {
        if (loadingGlobalTicket) {
            return
        }

        if (Array.isArray(storeTags) && storeTags.length > 0) {
            storeTagsRequestedRef.current = true
            return
        }

        if (storeTagsRequestedRef.current || storeTagsLoading) {
            return
        }

        storeTagsRequestedRef.current = true
        dispatch(fetchTicketStoreTags())
    }, [dispatch, storeTags, storeTagsLoading, loadingGlobalTicket])

    const pendingLoadMoreRef = useRef(false)
    const storesInitializedRef = useRef(false)
    const previousMultiTicktesRef = useRef(multiTicktes)

    // Paso 1: Función refactorizada para cargar tiendas con soporte para contextos separados
    const fetchLocalTicketStores = useCallback(async ({ context = 'single', page = 1, tags = [], search = '', append = false, hasResponsible = '' } = {}) => {
        // Incrementar requestId y guardar el valor actual para esta llamada
        requestIdRef.current += 1
        const currentRequestId = requestIdRef.current

        // Generar clave de cache (solo para page 1)
        const cacheKey = page === 1 ? `${context}-${[...tags].sort().join(',')}-${search}-${hasResponsible}` : null

        // Si es page 1 y está en cache, usar cache
        if (cacheKey && initialCacheRef.current.has(cacheKey)) {
            const cachedData = initialCacheRef.current.get(cacheKey)
            if (context === 'single') {
                setSingleStoresState(prev => ({
                    ...prev,
                    items: cachedData.items,
                    pagination: cachedData.pagination,
                    filters: { tags, search },
                }))
            } else {
                setMultiStoresState(prev => ({
                    ...prev,
                    baseItems: cachedData.items,
                    filteredItems: cachedData.items,
                    pagination: cachedData.pagination,
                    filters: { tags, search },
                    loading: false,
                }))
            }
            return
        }

        // Actualizar estado de loading según contexto
        if (context === 'single') {
            setSingleStoresState(prev => ({
                ...prev,
                pagination: { ...prev.pagination, loading: true },
            }))
        } else {
            setMultiStoresState(prev => ({
                ...prev,
                loading: true,
                pagination: { ...prev.pagination, loading: true },
            }))
        }

        try {
            const response = await apiFetchStores({
                ...buildResponsibleParams(hasResponsible, { page, pageSize: 100 }),
                sort: 'name',
                tags,
                tagMode: 'all',
                search,
            })

            // Descartar respuesta si hay una más reciente
            if (currentRequestId !== requestIdRef.current) {
                return
            }

            const storesResponse = response.data ?? {}
            const storeData = Array.isArray(storesResponse) ? storesResponse : storesResponse.data ?? []
            const visibleStores = storeData.filter(store => store.visible === 1)

            // Procesar metadata de paginación
            const meta = storesResponse.meta ?? {}
            const perPage = meta.per_page ?? meta.page_size ?? 100
            const currentPage = meta.current_page ?? meta.page ?? page
            const lastPage = meta.last_page ?? meta.total_pages ?? currentPage
            const totalRecords = meta.total ?? meta.record_count ?? visibleStores.length
            const hasMore = currentPage < lastPage || (totalRecords && currentPage * perPage < totalRecords)
            const nextPage = hasMore ? currentPage + 1 : null

            const paginationData = {
                page: currentPage,
                perPage,
                lastPage,
                total: totalRecords,
                hasMore,
                nextPage,
                loading: false,
            }

            // Actualizar estado según contexto
            if (context === 'single') {
                setSingleStoresState(prev => {
                    let mergedStores
                    if (!append) {
                        mergedStores = visibleStores
                    } else {
                        // Deduplicación al agregar más páginas
                        const seen = new Set()
                        const nextStores = []

                        prev.items.forEach(store => {
                            const key = Number(store.id)
                            if (!seen.has(key)) {
                                seen.add(key)
                                nextStores.push(store)
                            }
                        })

                        visibleStores.forEach(store => {
                            const key = Number(store.id)
                            if (!seen.has(key)) {
                                seen.add(key)
                                nextStores.push(store)
                            }
                        })

                        mergedStores = nextStores
                    }

                    // Guardar en cache si es page 1
                    if (cacheKey && page === 1) {
                        initialCacheRef.current.set(cacheKey, {
                            items: mergedStores,
                            pagination: paginationData,
                        })
                    }

                    return {
                        items: mergedStores,
                        pagination: paginationData,
                        filters: { tags, search },
                    }
                })
            } else {
                // Modo multi: actualizar baseItems y sincronizar con filteredItems
                setMultiStoresState(prev => {
                    let mergedStores
                    if (!append) {
                        mergedStores = visibleStores
                    } else {
                        const seen = new Set()
                        const nextStores = []

                        prev.baseItems.forEach(store => {
                            const key = Number(store.id)
                            if (!seen.has(key)) {
                                seen.add(key)
                                nextStores.push(store)
                            }
                        })

                        visibleStores.forEach(store => {
                            const key = Number(store.id)
                            if (!seen.has(key)) {
                                seen.add(key)
                                nextStores.push(store)
                            }
                        })

                        mergedStores = nextStores
                    }

                    // Formatear y filtrar tiendas según tipo de operador
                    const selectedIds = new Set(multiStoresRef.current.map(store => Number(store.id)))
                    let stores = formatterInputSelectData(mergedStores)

                    // Usuario normal: filtrar por sus tiendas (teams)
                    if (multiTicktes && userMultipleTicketsId) {
                        const userStores = getUserById(dataUsersAndStores, userMultipleTicketsId) || []
                        const allowedIds = new Set(userStores.map(store => Number(store.id)))
                        stores = stores.filter(store => allowedIds.has(Number(store.id)))
                    }

                    const filtered = stores
                        .map(store => ({
                            ...store,
                            label: store.label ?? store.name ?? '',
                            checked: selectedIds.has(Number(store.id)),
                        }))
                        .sort((a, b) => (a.label ?? '').localeCompare(b.label ?? '', undefined, { sensitivity: 'base' }))

                    // Actualizar checkedAllStores
                    const allSelected = filtered.length > 0 && filtered.every(store => store.checked)
                    setCheckedAllStores(allSelected)

                    return {
                        ...prev,
                        baseItems: mergedStores,
                        filteredItems: filtered,
                        pagination: paginationData,
                        loading: false,
                        filters: { tags, search },
                    }
                })
            }

            if (!hasMore) {
                pendingLoadMoreRef.current = false
            }

        } catch (error) {
            // Descartar error si hay una request más reciente
            if (currentRequestId !== requestIdRef.current) {
                return
            }

            console.error('Error fetching local ticket stores:', error)

            if (context === 'single') {
                setSingleStoresState(prev => ({
                    ...prev,
                    pagination: { ...prev.pagination, loading: false },
                }))
            } else {
                setMultiStoresState(prev => ({
                    ...prev,
                    loading: false,
                    pagination: { ...prev.pagination, loading: false },
                }))
            }
        }
    }, [multiTicktes, userMultipleTicketsId, dataUsersAndStores, getUserById])

    // Paso 3: Handler de paginación para modo "una tienda"
    const handleLoadMoreStores = useCallback(() => {
        if (!singleStoresState.pagination?.hasMore) {
            return
        }
        if (singleStoresState.pagination.loading) {
            pendingLoadMoreRef.current = true
            return
        }
        if (!singleStoresState.pagination.nextPage) {
            return
        }
        const tags = singleStoresState.filters?.tags ?? []
        const search = singleStoresState.filters?.search ?? ''
        fetchLocalTicketStores({ context: 'single', page: singleStoresState.pagination.nextPage, append: true, tags, search })
    }, [fetchLocalTicketStores, singleStoresState.pagination?.hasMore, singleStoresState.pagination?.loading, singleStoresState.pagination?.nextPage, singleStoresState.filters])

    // Paso 5: Búsqueda en modo único ticket con contexto 'single'
    const handleStoreSearchDebounce = useCallback(
        debounce((searchValue, tags) => {
            setIsSearching(true)
            fetchLocalTicketStores({ context: 'single', page: 1, search: searchValue, tags, append: false })
                .finally(() => setIsSearching(false))
        }, 500),
        [fetchLocalTicketStores]
    )

    const handleStoreInputChange = useCallback((inputValue, actionMeta) => {
        if (actionMeta.action === 'input-change') {
            setStoreSearchInput(inputValue)
            const MIN_CHARS = 2
            if (inputValue.length >= MIN_CHARS || inputValue.length === 0) {
                handleStoreSearchDebounce(inputValue, tempSelectedTags)
            }
        } else if (actionMeta.action === 'menu-close' && storeSearchInput) {
            // Mantener el input de búsqueda cuando se cierra el menú
            // No hacer nada aquí, solo prevenir que se borre
        }
    }, [handleStoreSearchDebounce, tempSelectedTags, storeSearchInput])

    const handleStoreClear = useCallback(() => {
        setStoreSearchInput('')
        setIsSearching(false)
        handleStoreSearchDebounce.cancel?.()
        // Paso 5: Recargar tiendas sin filtro de búsqueda pero mantener tags
        fetchLocalTicketStores({ context: 'single', page: 1, tags: tempSelectedTags, search: '', append: false })
    }, [fetchLocalTicketStores, tempSelectedTags, handleStoreSearchDebounce])

    const handleStoreMenuOpen = useCallback(() => {
        // Cuando se abre el menú, limpiar la búsqueda y recargar todas las tiendas
        if (storeSearchInput) {
            setStoreSearchInput('')
            setIsSearching(false)
            handleStoreSearchDebounce.cancel?.()
            fetchLocalTicketStores({ context: 'single', page: 1, tags: tempSelectedTags, search: '', append: false })
        }
    }, [storeSearchInput, fetchLocalTicketStores, tempSelectedTags, handleStoreSearchDebounce])

    const handleStoreMenuClose = useCallback(() => {
        // Cuando se cierra el menú, si hay búsqueda activa, limpiar y recargar para la próxima apertura
        if (storeSearchInput) {
            setStoreSearchInput('')
            setIsSearching(false)
            handleStoreSearchDebounce.cancel?.()
            fetchLocalTicketStores({ context: 'single', page: 1, tags: tempSelectedTags, search: '', append: false })
        }
    }, [storeSearchInput, fetchLocalTicketStores, tempSelectedTags, handleStoreSearchDebounce])

    // Paso 2/3: Detectar cuando termina la carga para búsquedas
    useEffect(() => {
        if (!singleStoresState.pagination?.loading && isSearching) {
            setIsSearching(false)
        }

        if (!singleStoresState.pagination?.loading && pendingLoadMoreRef.current) {
            const shouldLoadMore = singleStoresState.pagination?.hasMore
            pendingLoadMoreRef.current = false
            if (shouldLoadMore) {
                handleLoadMoreStores()
            }
        }
    }, [singleStoresState.pagination?.loading, singleStoresState.pagination?.hasMore, isSearching, handleLoadMoreStores])

    const resetStoreFilters = useCallback(() => {
        setTempSelectedTags([])
        setStoreSearchInput('')
        setIsSearching(false)
        setMultiStores([])
        setMultiStoresState(prev => ({ ...prev, baseItems: [], filteredItems: [], filters: { tags: [], search: '' }, hasResponsible: '' }))
        setCheckedAllStores(false)
        setSearchResults([])
        setStoreListOpen(true)
        lastToggledIndexRef.current = null
        formikRef.current?.setFieldValue('store_id', "")
        handleStoreSearchDebounce.cancel?.()
        // Paso 2: Recargar tiendas locales sin filtros en contexto 'single'
        fetchLocalTicketStores({ context: 'single', page: 1, tags: [], search: '', append: false })
        dispatch(setStoreFilters({ tags: [], search: '' }))
    }, [dispatch, fetchLocalTicketStores, handleStoreSearchDebounce])

    // Paso 2: Carga inicial al montar el modal
    useEffect(() => {
        if (!storesInitializedRef.current) {
            fetchLocalTicketStores({ context: 'single', page: 1, tags: [], search: '', append: false })
            storesInitializedRef.current = true
        }
    }, [fetchLocalTicketStores])

    useEffect(() => {
        setTempSelectedTags(singleStoresState.filters?.tags ?? [])
    }, [singleStoresState.filters?.tags])

    // COMENTADO: Este useEffect limpiaba la selección cuando la tienda no estaba en los items actuales
    // Causaba el bug donde al buscar una tienda que no estaba en las primeras 98, se seleccionaba pero luego se borraba
    // La solución correcta es mantener la tienda seleccionada en las opciones del Select (ver líneas 2718-2735)

    // useEffect(() => {
    //     // Solo verificar en modo single y cuando hay filtros aplicados
    //     if (multiTicktes || !singleStoresState.filters?.tags?.length) {
    //         return
    //     }

    //     const currentStoreId = formikRef.current?.values?.store_id?.id || formikRef.current?.values?.store_id?.value

    //     // Si hay una tienda seleccionada, verificar si sigue siendo válida
    //     if (currentStoreId && singleStoresState.items.length > 0 && !singleStoresState.pagination.loading) {
    //         const storeStillValid = singleStoresState.items.some(store => {
    //             const storeId = store.id || store.value
    //             return String(storeId) === String(currentStoreId)
    //         })

    //         // Si la tienda no está en los resultados filtrados, limpiar la selección
    //         if (!storeStillValid) {
    //             formikRef.current?.setFieldValue('store_id', "")
    //             formikRef.current?.setFieldValue('operator_id', "")
    //             formikRef.current?.setFieldTouched('operator_id', false)
    //         }
    //     }
    // }, [singleStoresState.items, singleStoresState.filters?.tags, multiTicktes, singleStoresState.pagination.loading])

    useEffect(() => {
        if (!storesInitializedRef.current) {
            previousMultiTicktesRef.current = multiTicktes
            return
        }

        if (previousMultiTicktesRef.current && !multiTicktes) {
            resetStoreFilters()
        }

        previousMultiTicktesRef.current = multiTicktes
    }, [multiTicktes, resetStoreFilters])

    // Paso 5: Aplicar filtro de etiquetas según contexto
    const applyTagFilter = useCallback((tagsToApply, options = {}) => {
        const normalized = tagsToApply ?? tempSelectedTags
        const currentSelection = multiTicktes
            ? (multiStoresState.filters?.tags ?? [])
            : (singleStoresState.filters?.tags ?? [])
        const isSameSelection = normalized.length === currentSelection.length && normalized.every((id, index) => String(id) === String(currentSelection[index]))

        if (!options.force && isSameSelection) {
            return
        }

        if (multiTicktes) {
            dispatch(setStoreFilters({ tags: normalized, search: storeSearchInput }))
            setMultiStoresState(prev => ({
                ...prev,
                loading: true,
                filters: { tags: normalized, search: storeSearchInput },
            }))
            setMultiStores([])
            setCheckedAllStores(false)
            setSearchResults([])
            formikRef.current?.setFieldValue('store_id', "")
            const currentHasResponsible = multiStoresStateRef.current.hasResponsible
            if (currentHasResponsible) {
                fetchLocalTicketStores({ context: 'multi', page: 1, tags: normalized, search: storeSearchInput, hasResponsible: currentHasResponsible })
            }
            return
        }

        setIsSearching(true)
        fetchLocalTicketStores({ context: 'single', page: 1, tags: normalized, search: storeSearchInput, append: false })
            .finally(() => setIsSearching(false))
    }, [dispatch, fetchLocalTicketStores, tempSelectedTags, singleStoresState.filters?.tags, multiStoresState.filters?.tags, storeSearchInput, multiTicktes])

    const handleTagFilterChange = useCallback((selectedTagIds) => {
        const normalized = Array.isArray(selectedTagIds) ? selectedTagIds : []
        setTempSelectedTags(normalized)
    }, [])

    const tagFilterContainerRef = useRef(null)

    const handleTagFilterFocus = useCallback((e) => {
        setTagFilterHasFocus(true)
        // En mobile y en modo multi-tiendas, scrollear el input de filtros
        // para que quede alineado al tope del contenedor scrolleable del modal.
        try {
            if (isMobile() && multiTicktes) {
                // Siguiente tick para asegurar que el menú haya calculado alturas
                setTimeout(() => {
                    const target = tagFilterContainerRef.current || e?.target
                    if (target && typeof target.scrollIntoView === 'function') {
                        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
                        return
                    }
                    // Fallback manual al contenedor del modal
                    const contentEl = document.querySelector('.base-modal-content')
                    const element = tagFilterContainerRef.current || e?.target
                    if (contentEl && element) {
                        const contentRect = contentEl.getBoundingClientRect()
                        const elemRect = element.getBoundingClientRect()
                        const delta = elemRect.top - contentRect.top
                        contentEl.scrollTop += delta
                    }
                }, 0)
            }
        } catch (e) {
            // Silenciar errores para no bloquear la UI
        }
    }, [multiTicktes])

    const handleTagFilterBlur = useCallback(() => {
        setTagFilterHasFocus(false)
    }, [])

    const handleTagFilterCancel = useCallback(() => {
        const applied = multiTicktes
            ? (multiStoresState.filters?.tags ?? [])
            : (singleStoresState.filters?.tags ?? [])
        setTempSelectedTags(applied)
        setTagFilterHasFocus(false)
    }, [multiTicktes, multiStoresState.filters?.tags, singleStoresState.filters?.tags])

    const handleTagMenuClose = useCallback((nextValue) => {
        setTagFilterHasFocus(false)
        applyTagFilter(nextValue)
    }, [applyTagFilter])

    const handleTagMenuApply = useCallback((nextValue) => {
        // Al aplicar desde el footer, cerrar estado de focus y aplicar forzado
        setTagFilterHasFocus(false)
        applyTagFilter(nextValue, { force: true })
    }, [applyTagFilter])

    const handleRemoveAppliedTag = useCallback((tagId) => {
        if (!appliedTagIds.length) {
            return
        }
        const updated = appliedTagIds.filter(id => String(id) !== String(tagId))
        setTempSelectedTags(updated)
        applyTagFilter(updated, { force: true })
    }, [appliedTagIds, applyTagFilter])

    const handleClearAppliedTags = useCallback(() => {
        if (!appliedTagIds.length) {
            return
        }
        setTempSelectedTags([])
        applyTagFilter([], { force: true })
    }, [appliedTagIds, applyTagFilter])




    function sortQuestionsByPriority(obj) {
        if (obj) {
            const sortedObj = JSON.parse(JSON.stringify(obj));
            sortedObj.questions.sort((a, b) => a.priority - b.priority);
            return sortedObj;
        }
    }

    useEffect(() => {
        if (search_question_group) {
            ticketCategoryById && apiGetTicketsCategoriesById(ticketCategoryById).then((res) => {
                const { data } = res
                if (res.data) {
                    setQuestionGroupId(data.data.question_group_primary_id);
                    setQuestionGroup(sortQuestionsByPriority(data.data.question_group_primary[0]))
                    setQuestionLoading(true)
                    // Otro cuestionario arranca sin errores a la vista.
                    setIdsExigidos(new Set())
                }
            }
            )
            setQuestionLoading(false)
        }
    }, [ticketCategoryById])



    const getTicketCategoriExpiration = async (body) => {
        if (search_expiration_date) {
            const { store_id, ticket_category_id } = body
            if (store_id && ticket_category_id) {
                setLoadingTicketExpiration(true)
                try {
                    const { data } = await apiTicketExpiration(body)
                    setTicketExpiredAt(data.expired_at)
                } catch (error) {
                    console.log(error);
                }
                setLoadingTicketExpiration(false)
            }
        }
    }

    const getStoreUsers = async (storeId) => {
        setTicketUsers([])
        setStoreAvailableRoles([])
        setStoreResponsableMap({})
        setLoadingStores(true)
        try {
            const resStores = await apiGetStoreById(storeId)
            const { props } = resStores.data.data
            const users = formatterInputSelectData(props.users_allowed)
            setTicketUsers(users)

            const roles = RESPONSIBLE_ROLES.filter(role => {
                const value = props[getRolePropKey(role)]
                return Array.isArray(value) ? value.length > 0 : Boolean(value)
            })
            setStoreAvailableRoles(roles)

            const rMap = {}
            roles.forEach(role => {
                const roleUsers = props[getRolePropKey(role)]
                if (Array.isArray(roleUsers)) {
                    rMap[role] = roleUsers
                }
            })
            setStoreResponsableMap(rMap)
        } catch (error) {
            console.log(error);
        }
        setLoadingStores(false)
    }

    // answers

    const [answersCheckBox, setAnswersCheckBox] = useState([]);
    const [filesQuestions, setFilesQuestions] = useState([])

    const hasExternalChanges = useMemo(() => files.length > 0 || filesQuestions.length > 0, [files, filesQuestions])


    const onUploadFilesQuestion = (file, id) => {
        const files = Array.isArray(file) ? file : [file]
        setFilesQuestions((prevState) => {
            let updatedFiles = [...prevState];
            // Verificar si ya existe un archivo con el mismo id
            const existingFileIndex = prevState.findIndex((item) => item.id === id);
            if (existingFileIndex !== -1) {
                // Reemplazar el archivo existente
                updatedFiles[existingFileIndex] = { id, files: renameFile(files) };
            } else {
                // Agregar un nuevo archivo
                updatedFiles = [...updatedFiles, { id, files: renameFile(files) }]
            }
            return updatedFiles
        });
        return files
    };

    const removeFileState = (file, id) => {
        let questionsFile = structuredClone(filesQuestions)
        const fileIndex = filesQuestions.findIndex((item) => item.id === id);
        let answerFile = questionsFile[fileIndex]
        const filesFilter = answerFile.files?.filter(f => f.lastModified !== file.lastModified)
        if (filesFilter.length < 1) {
            questionsFile = questionsFile.filter((q, index) => index !== fileIndex)
        } else {
            answerFile.files = filesFilter
        }
        setFilesQuestions(questionsFile)
        return filesFilter
    }

    const setFilesValues = (question, values, type) => {
        let response = undefined
        if (type === 'change_files') {
            response = onUploadFilesQuestion(values, question)
        }
        if (type === 'remove_file') {
            response = removeFileState(values, question)
        }
        return response.length > 0 ? response : undefined
    }

    const createAnswers = (response) => {
        const { question_id, id } = response;
        const objKey = { [question_id]: id }
        const responseObj = { ...answersCheckBox };
        const objFound = answersCheckBox.find(obj => JSON.stringify(obj) === JSON.stringify(objKey));
        if (objFound) {
            delete responseObj[objKey];
            const newanswersCheckBox = answersCheckBox.filter(obj => JSON.stringify(obj) !== JSON.stringify(objKey));
            setAnswersCheckBox(newanswersCheckBox)
        } else {
            responseObj[objKey] = { [question_id]: id };
            setAnswersCheckBox([...answersCheckBox, responseObj[objKey] = { [question_id]: id }]);
        }

    }


    const getFormInLS = () => {
        const ls = getKey(QUESTION_PRIMARY_KEY)
        if (ls) {
            return JSON.parse(ls)
        } else {
            setKey(QUESTION_PRIMARY_KEY, JSON.stringify({}))
            return {}
        }
    }

    const saveFormInLocalStorage = (data) => {
        const { question, type, value } = data

        let questionGroup = getFormInLS()
        let newValue = value

        if (questionGroup) {
            if (type === FILE || type === AI_VISUAL_CHECK) {
                return
            }
            if (type === CHECKBOX) {
                newValue = newValue ? JSON.parse(newValue) : undefined
            }
            questionGroup[question] = newValue
            setKey(QUESTION_PRIMARY_KEY, JSON.stringify(questionGroup))
        }
    }


    const viewTicket = (id) => {
        navigate(`/tickets/inbox?ticket=${id}`)
    }

    const handleCopyClick = (id) => {
        navigator.clipboard.writeText(`${window.location.origin}/tickets/inbox?ticket=${id}`)
        toast.push(
            <Notification title={t('copied')} type="success" duration={1000} />
            , {
                placement: 'top-center'
            })
    }


    // `visiblesIds` filtra lo que se manda. La limpieza al cambiar de rama ya deberia
    // dejar el localStorage sin las respuestas ocultas, pero esto es la ultima linea:
    // un borrador guardado antes de este cambio, o una recarga con la rama ya cerrada,
    // llegan aca con datos que el usuario no ve.
    const submitQuestions = (visiblesIds) => {
        const arrayOfAnswersLS = [];

        try {
            /* if (answersCheckBox.length > 0) {
                answersCheckBox.forEach(function (obj) {
                    let key = Object.keys(obj)[0];
                    let value = obj[key];
                    let newObj = {
                        id: key,
                        question_option_id: value
                    };
                    arrayOfAnswers.push(newObj);
                });
            } */

            const formLS = getFormInLS()
            const formValues = Object.keys(formLS)
                .filter(key => !visiblesIds || visiblesIds.has(String(key)))
                .map(key => ({
                    key,
                    value: formLS[key],
                    type: typeof (formLS[key])
                }));

            formValues.map(answer => {

                if (answer.type === STRING) {
                    arrayOfAnswersLS.push({
                        id: answer.key,
                        value: answer.value.trim(),
                    })
                }
                if (answer.type === NUMBER) {
                    arrayOfAnswersLS.push({
                        id: answer.key,
                        question_option_id: answer.value
                    })
                }

                if (answer.type === OBJECT) {
                    answer.value.map(value => value && arrayOfAnswersLS.push({
                        id: answer.key,
                        question_option_id: value
                    }))
                }
            })


            const fileAnswer = filesQuestions
                .filter(obj => !visiblesIds || visiblesIds.has(String(obj.id)))
                .reduce((result, obj) => {
                    const filesArray = obj.files.map(f => ({ id: obj.id.toString(), file: f }));
                    return result.concat(filesArray);
                }, []);
            arrayOfAnswersLS.push(...fileAnswer)

        } catch (error) {
            console.log(error);
        }
        return arrayOfAnswersLS
    };


    const onUpload = (file, type) => {
        let list = file
        if (type === 'remove_file') {
            list = files.filter(f => f.lastModified !== file.lastModified)
        }
        setFiles(list)
    }

    const [initialValuesForm, setInitialValuesForm] = useState({
        store_id: addTicketFromCameras && storeForTicket ? formatterInputSelectData(storeForTicket) : "",
        ticket_category_id: "",
        parent_category: "",
        operator_id: "",
        description: "",
        record_id: addTicketFromCameras && recordForTicket ? recordForTicket.id : null,
        device_id: addTicketFromCameras && deviceForTicket ? deviceForTicket.id : null,
        second_start: null,
    })

    function addPropertiesToInitialValues(initialValues, questions) {
        const newInitialValues = { ...initialValues };
        const formLs = getFormInLS()
        questions.forEach((question) => {
            let value = formLs[question.id]
            const defaultValue = question.question_type_id === 4 ? (value ?? "") : (value ?? undefined); // define un valor predeterminado basado en el tipo de pregunta
            const propertyName = question.id; // crea el nombre de propiedad basado en el id de la pregunta
            newInitialValues[propertyName] = defaultValue;
        });

        setInitialValuesForm(newInitialValues);
    }

    useEffect(() => {
        questionGroup && addPropertiesToInitialValues(initialValuesForm, questionGroup?.questions)
    }, [questionGroup])



    // Las preguntas del cuestionario ya no entran al schema de Yup: cuales se ven depende
    // de las respuestas y cambia en cada render, y un schema armado una sola vez seguiria
    // exigiendo una pregunta que la respuesta del padre dejo oculta. Van por `validate`
    // (validarPreguntasVisibles), que Formik corre ademas de este schema y mergea.
    const validationSchema = useMemo(() => {
        let validation = Yup.object();

        validation = validation.shape({
            parent_category: Yup.object().required('Seleccione una categoria'),
            ticket_category_id: Yup.object().required('Seleccione una tarea'),
            store_id: Yup.mixed().required(`Seleccione una ${t("store_alias").toLowerCase()}`),
            description: Yup.string().nullable(),
            operator_id: Yup.object().required('Seleccione un operador'),
            record_id: Yup.number().nullable().notRequired(),
            device_id: Yup.number().nullable().notRequired(),
            second_start: Yup.number().nullable().notRequired(),
        });

        if (showTicketScheduleForm) {
            validation = validation.shape({
                title: Yup.string().nullable(),
                recurrence: Yup.string().required('Este campo es requerido'),
                start_time: Yup.date().required('Este campo es requerido')
                    .min(
                        new Date(new Date().getTime() + 60 * 60 * 1000),
                        'La fecha y hora de inicio deben ser al menos 1 hora mayor que la hora actual'
                    ),
                end_time: Yup.date().when('recurrence', {
                    is: (val) => val && val !== 'none',
                    then: (schema) => schema
                        .required('Este campo es requerido')
                        .test(
                            'after-start',
                            'La fecha debe ser mayor que la fecha de inicio',
                            function (value) {
                                const { start_time } = this.parent;
                                if (!start_time || !value) return true;
                                return new Date(value) > new Date(start_time);
                            }
                        ),
                    otherwise: (schema) => schema.nullable().notRequired(),
                })
            })
        }

        return validation;
    }, [showTicketScheduleForm, t]);

    // Las preguntas del cuestionario, ya filtradas por `visible`. Es la lista COMPLETA:
    // que subconjunto se ve depende de las respuestas y se resuelve en cada render.
    const preguntasDelGrupo = useMemo(
        () => filterVisibleQuestions(questionGroup?.questions || []),
        [questionGroup]
    )

    const validarPreguntasVisibles = (values) => {
        const errores = {}
        if (!questionGroupId) return errores
        const { visibles } = resolverVisibles(preguntasDelGrupo, values)
        for (const q of visibles) {
            if (q.question_type_id === TITLE) continue
            const valor = values[q.id]
            if ((q.question_type_id === TEXT || q.question_type_id === TEXTAREA)
                && typeof valor === 'string'
                && valor.length > 400) {
                errores[q.id] = 'El campo debe ser menor que 400 caracteres'
                continue
            }
            if (q.required && !estaRespondida(valor)) {
                errores[q.id] = 'Esta pregunta es obligatoria'
            }
        }
        return errores
    }

    // Al cambiar la respuesta de un padre, la rama vieja deja de verse pero sus valores
    // siguen en Formik y en localStorage, y el submit los reconstruye desde ahi: sin esta
    // limpieza el backend recibe la respuesta de una pregunta que el usuario ya no ve.
    // Se calcula por diferencia y no bajando por los descendientes, porque en un CHECKBOX
    // se puede destildar una opcion y dejar tildada otra que abre la misma hija.
    const limpiarRamaOculta = (form, values, questionId, nuevoValor) => {
        const valuesDespues = { ...values, [questionId]: nuevoValor }
        const ocultos = idsQueSeOcultan(preguntasDelGrupo, values, valuesDespues)
        if (ocultos.length === 0) return
        const guardado = getFormInLS()
        for (const id of ocultos) {
            form.setFieldValue(id, undefined)
            delete guardado[id]
        }
        setKey(QUESTION_PRIMARY_KEY, JSON.stringify(guardado))
    }


    const postTicketScheduled = async (data, setSubmitting) => {
        const payload = {
            stores: data.stores,
            description: data.description,
            operator_id: getOperatorId(data.operator_id),
            ticket_category_id: data.ticket_category_id.id,
        }
        const body = {
            start_time: formatDateInput(data.start_time),
            end_time: formatDateInput(data.end_time),
            payload: payload,
            title: data.title,
            recurrence: data.recurrence,
            ticket_category_id: data.ticket_category_id.id
        }

        try {
            const { status, data } = await apiPostTicketSchedule(body)
            if (status === statusResponse.CREATE) {
                dispatch(setTicketScheduleList([data.data, ...ticketScheduleList]))
                dispatch(toggleTicketDialog(false));
                toast.push(
                    <Notification title={t("created")} type="success" duration={2500}>
                        {`${t("ticket_schedule_created")}`} 
                    </Notification>
                );
            }
        } catch (error) {
            handleTicketError(error, t)
        }
        setSubmitting(false)

    }



    const onSubmit = async (formValue, setSubmitting, resetForm) => {
        const {
            store_id,
            operator_id,
            ticket_category_id,
            record_id,
            device_id,
        } = formValue;

        let description = formValue.description
        let ticketFiles = files

        if (description) {
            //Recupero las imagenes de la descripcion y las paso como file
            const descriptionData = await getDescriptionImages(description)
            description = descriptionData.elements
            ticketFiles = [...ticketFiles, ...descriptionData.files]
        }

        const stores = multiStores.length > 0 ? createArrayWithItemId(multiStores) : createArrayWithItemId(store_id)

        setSubmitting(true);
        if (showTicketScheduleForm) {
            postTicketScheduled({ ...formValue, description, stores, files: ticketFiles }, setSubmitting)
            return
        }

        const ticketFormData = new FormData();
        ticketFormData.append("operator_id", getOperatorId(operator_id));
        ticketFormData.append("ticket_category_id", ticket_category_id.id);
        description && ticketFormData.append("description", description);
        ticketExpiredAt &&
            ticketFormData.append(
                "expired_at",
                dayjs(ticketExpiredAt).format("YYYY-MM-DD HH:mm:ss")
            );
        record_id && ticketFormData.append("record_id", record_id);
        device_id && ticketFormData.append("device_id", device_id);
        secondsForTicket > 0 && ticketFormData.append("second_start", secondsForTicket);
        parentIdForTicket && ticketFormData.append("parent_id", parentIdForTicket)

        ticketFiles?.length &&
            ticketFiles.map((file) => {
                ticketFormData.append("files[]", file);
            });

        const { visibles } = resolverVisibles(preguntasDelGrupo, formValue)
        const visiblesIds = new Set(visibles.map(q => String(q.id)))

        const answerQuestion = {
            question_group_id: questionGroupId,
            questions: submitQuestions(visiblesIds),
        };

        try {
            const requests = stores.map(async (storeId) => {

                const formData = new FormData();

                for (const [key, value] of ticketFormData.entries()) {
                    formData.append(key, value);
                }
                formData.append("store_id", storeId);

                const { status, data } = await apiPostTicket(formData);
                if (status === statusResponse.CREATE) {
                    // Esperamos el guardado del cuestionario ANTES de resolver:
                    // si no se await-ea, Promise.all resuelve apenas se crea el
                    // hallazgo y el modal cierra/limpia localStorage dejando las
                    // respuestas sin enviar (answers: 0). Mismo patron que en
                    // TicketQuestion.js y TicketQuestionHome.js.
                    if (questionGroupId) {
                        try {
                            await apiPostAnswerTicket(data.data.id, jsonToFormData(answerQuestion));
                        } catch (answerError) {
                            // El hallazgo ya existe; avisamos sin abortar la creacion.
                            // Surface del mensaje real del backend (ej: rechazo al
                            // registrar una incidencia) para que el error no quede
                            // invisible como antes (era fire-and-forget).
                            const backendMsg = answerError?.response?.data?.message
                            toast.push(
                                <Notification title={t('warning')} type="warning" duration={7000}>
                                    {t('questionnaire_save_failed', { defaultValue: 'El hallazgo se creó, pero no se pudieron guardar las respuestas del cuestionario.' })}
                                    {backendMsg ? ` (${backendMsg})` : ''}
                                </Notification>
                            )
                        }
                    }
                    return data.data;
                }
            });

            const results = await Promise.all(requests);
            const createdTickets = results.filter((ticket) => ticket !== undefined);


                if (createdTickets.length > 0) {
                    setSubmitting(false);
                    deleteKey(QUESTION_PRIMARY_KEY)
                    resetForm(true);
                    setFiles([]);
                    setFilesQuestions([]);
                    // Refetch de la vista activa en vez de prepend a ciegas: el
                    // prepend mostraba el hallazgo aunque no perteneciera a la
                    // vista (ej: asignado a otro en "Mis hallazgos"). Refetchear
                    // deja la lista igual que un refresh manual, que respeta el
                    // filtro del backend (fuente de verdad).
                    dispatch(getTickets({ query: tableData.queryInbox, pageIndex: tableData.pageIndex }));

                toast.push(
                    <Notification title={t("created")} type="success" duration={5000}>
                        {t("ticket_successCreated")}
                        {createdTickets.length === 1 &&
                            <div className='flex gap-3 justify-between mt-2'>
                                <span className='font-semibold cursor-pointer text-indigo-600 dark:text-white' onClick={() => { viewTicket(createdTickets[0].id) }}>{t('can_view') + ' ' + t('ticket_alias')}</span>
                                <span className='font-semibold cursor-pointer text-indigo-600 dark:text-white' onClick={() => { handleCopyClick(createdTickets[0].id) }}>{t("copy_link")}</span>
                            </div>
                        }
                    </Notification>
                );
            }
        } catch (error) {
            setSubmitting(false);
            handleTicketError(error, t)
        }


        dispatch(resetValuesForTicket())
        dispatch(toggleTicketDialog(false));
    };

    const onCheckIsMultiple = (value) => {
        setTicketsMultiple(value)
        setInitialValuesForm(initialValuesForm)
        resetStoreFilters()
        onResponsibleChange?.(false)
        // Paso 2: Recargar tiendas locales sin filtros cuando se cambia de modo
        if (!value) {
            // Modo único: recargar tiendas sin filtros
            fetchLocalTicketStores({ context: 'single', page: 1, tags: [], search: '', append: false })
        }
    }

    const handleToggle = () => setStoreListOpen(prev => !prev)

    // Helper memo para determinar la lista visible y contadores
    const { visibleStores, visibleTotalCount, visibleSelectedCount, areAllVisibleSelected } = useMemo(() => {
        const visible = searchResults.length > 0 ? searchResults : multiStoresState.filteredItems;
        const paginationTotal = multiStoresState.pagination?.total ?? 0
        const displayTotal = paginationTotal > visible.length ? paginationTotal : visible.length;
        const selectedIds = new Set(multiStores.map(s => s.id));
        const selectedCount = visible.filter(store => selectedIds.has(store.id)).length;
        // allSelected se basa en tiendas visibles (cargadas), no en el total del backend
        const allSelected = visible.length > 0 && selectedCount === visible.length;

        return {
            visibleStores: visible,
            visibleTotalCount: displayTotal,
            visibleSelectedCount: selectedCount,
            areAllVisibleSelected: allSelected
        };
    }, [searchResults, multiStoresState.filteredItems, multiStoresState.pagination?.total, multiStores]);

    // Paso 7: Selección masiva con nuevo estado
    const selectAllStores = useCallback((shouldSelect = !areAllVisibleSelected) => {
        // Obtener IDs visibles
        const visibleIds = new Set(visibleStores.map(store => store.id));

        // Actualizar multiStoresState.filteredItems solo para los IDs visibles
        setMultiStoresState(prev => ({
            ...prev,
            filteredItems: prev.filteredItems.map(store =>
                visibleIds.has(store.id) ? { ...store, checked: shouldSelect } : store
            )
        }));

        // Actualizar searchResults solo para los IDs visibles
        if (searchResults.length > 0) {
            setSearchResults(prev =>
                prev.map(store =>
                    visibleIds.has(store.id) ? { ...store, checked: shouldSelect } : store
                )
            );
        }

        // Actualizar multiStores añadiendo o eliminando elementos visibles sin duplicados
        if (shouldSelect) {
            setMultiStores(prev => {
                const existingIds = new Set(prev.map(s => s.id));
                const newStores = visibleStores
                    .filter(store => !existingIds.has(store.id))
                    .map(store => ({ ...store, checked: true }));
                return [...prev, ...newStores];
            });
        } else {
            setMultiStores(prev => prev.filter(store => !visibleIds.has(store.id)));
        }

        // Fijar checkedAllStores según el helper
        setCheckedAllStores(shouldSelect);

        // Reset del índice de Shift+Click (mantener búsqueda)
        lastToggledIndexRef.current = null;
    }, [areAllVisibleSelected, visibleStores, searchResults])
    // multiStoresState.filteredItems muestra todas las tiendas que se pueden seleccionar.
    // multiStores es el array que se agregan las tiendas seleecionadas.
    // searchResults es el array que muestra las tiendas filtradas.

    // Paso 7: Toggle simple de tienda
    const toggleStoreSelection = useCallback((item, shouldSelect) => {
        const storesMultipleTicketsIndex = multiStoresState.filteredItems.findIndex(store => store.id === item.id);

        if (shouldSelect) {
            const updatedItem = { ...item, checked: true };
            setMultiStores(prev => {
                // Evitar duplicados
                if (prev.some(store => store.id === item.id)) {
                    return prev;
                }
                return [...prev, updatedItem];
            });

            // Actualizar multiStoresState.filteredItems solo si contiene el id
            if (storesMultipleTicketsIndex !== -1) {
                setMultiStoresState(prev => {
                    const updatedFiltered = [...prev.filteredItems];
                    updatedFiltered[storesMultipleTicketsIndex] = { ...item, checked: true };
                    return { ...prev, filteredItems: updatedFiltered };
                });
            }

            // Actualizar searchResults solo si contiene el id
            if (searchResults.length > 0) {
                const searchResultsIndex = searchResults.findIndex(store => store.id === item.id);
                if (searchResultsIndex !== -1) {
                    const updatedSearchResults = [...searchResults];
                    updatedSearchResults[searchResultsIndex] = { ...item, checked: true };
                    setSearchResults(updatedSearchResults);
                }
            }
        } else {
            setMultiStores(prev => prev.filter(store => store.id !== item.id));

            // Actualizar multiStoresState.filteredItems solo si contiene el id
            if (storesMultipleTicketsIndex !== -1) {
                setMultiStoresState(prev => {
                    const updatedFiltered = [...prev.filteredItems];
                    updatedFiltered[storesMultipleTicketsIndex] = { ...item, checked: false };
                    return { ...prev, filteredItems: updatedFiltered };
                });
            }

            // Actualizar searchResults solo si contiene el id
            if (searchResults.length > 0) {
                const searchResultsIndex = searchResults.findIndex(store => store.id === item.id);
                if (searchResultsIndex !== -1) {
                    const updatedSearchResults = [...searchResults];
                    updatedSearchResults[searchResultsIndex] = { ...item, checked: false };
                    setSearchResults(updatedSearchResults);
                }
            }
        }
        // No se actualiza checkedAllStores aquí, lo hará el useEffect
    }, [multiStoresState.filteredItems, searchResults]);

    // Función principal con soporte de Shift+Click
    const handleStoreCheckbox = useCallback((event, store, visibleIndex, visibleList) => {
        if (event?.shiftKey && lastToggledIndexRef.current !== null && lastToggledIndexRef.current !== visibleIndex) {
            // Shift+Click: selección de rango
            const start = Math.min(lastToggledIndexRef.current, visibleIndex);
            const end = Math.max(lastToggledIndexRef.current, visibleIndex);

            // Determinar si vamos a seleccionar o deseleccionar basándonos en el estado actual del store clickeado
            const shouldSelect = !store.checked;

            // Aplicar el estado a todas las tiendas en el rango
            for (let i = start; i <= end; i++) {
                const storeInRange = visibleList[i];
                if (storeInRange) {
                    toggleStoreSelection(storeInRange, shouldSelect);
                }
            }
        } else {
            // Click normal: toggle simple
            const isCurrentlySelected = multiStoresRef.current.some(s => s.id === store.id);
            toggleStoreSelection(store, !isCurrentlySelected);
        }

        // Actualizar el último índice clickeado
        lastToggledIndexRef.current = visibleIndex;
    }, [toggleStoreSelection]);

    // Mantener función legacy para compatibilidad con selectAllStores
    const selectedStores = (item) => {
        const isCurrentlySelected = multiStoresRef.current.some(s => s.id === item.id);
        toggleStoreSelection(item, !isCurrentlySelected);
    };

    const modifyAndSortArray = (arr) => {
        const modifiedArray = arr.map(item => ({ ...item, checked: false }))
            .filter(item => item.visible)
            .sort((a, b) => a.label.localeCompare(b.label));
        return modifiedArray;
    }

    const handleMultiStoreScroll = useCallback((e) => {
        const state = multiStoresStateRef.current
        if (!state.pagination?.hasMore || state.pagination?.loading) {
            return
        }
        const { scrollTop, scrollHeight, clientHeight } = e.target
        if (scrollHeight - scrollTop - clientHeight > 100) {
            return
        }
        const tags = state.filters?.tags ?? []
        const search = state.filters?.search ?? ''
        fetchLocalTicketStores({ context: 'multi', page: state.pagination.nextPage, append: true, tags, search, hasResponsible: state.hasResponsible ?? '' })
    }, [fetchLocalTicketStores])

    const onSearch = e => {
        const query = e.target.value;
        if (query === '') {
            setSearchResults([]);
            handleDebounceFn.cancel?.();
        } else {
            handleDebounceFn(query);
        }
    };

    // Recalcular checkedAllStores cuando cambia la lista visible o la selección
    useEffect(() => {
        setCheckedAllStores(areAllVisibleSelected);
    }, [areAllVisibleSelected]);

    // Limpiar búsqueda cuando cambia el usuario o se desmonta
    useEffect(() => {
        return () => {
            handleDebounceFn.cancel?.();
            if (multiStoreSearchAbortRef.current) {
                multiStoreSearchAbortRef.current.abort();
            }
        };
    }, [handleDebounceFn, userMultipleTicketsId]);

    const modules = useMemo(
        () => ({
            toolbar: {
                container: [
                    [{ header: [2, 3, 4, false] }],
                    [{ 'size': ['small', false, 'large'] }],
                    ["bold", "italic", "underline"],
                    [{ color: [] }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
                    [{ 'align': [] }],
                    /*   ["link" ], */
                    ["clean"],
                ],
            },
            clipboard: {
                matchVisual: true,
            },
        }),
    );


    const tagFilterStyle = useMemo(() => {
        const hasFilters = appliedTagIds.length > 0
        return {
            control: (base) => ({
                ...base,
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                borderRadius: '9999px',
                cursor: 'pointer',
                ':hover': { backgroundColor: 'transparent' }
            }),
            placeholder: (base) => ({
                ...base,
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                padding: 0,
                color: 'inherit',
                pointerEvents: 'none',
                overflow: 'visible',
                flexWrap: 'nowrap',
            }),
            valueContainer: (base) => ({
                ...base,
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                padding: '0 12px',
                paddingLeft: '2.25rem',
                paddingRight: hasFilters ? '2.75rem' : '2rem',
                minWidth: 0,
                flexWrap: 'nowrap',
                pointerEvents: 'auto',
                overflow: 'hidden',
                gap: '0.5rem',
            }),
            indicatorsContainer: (base) => ({ ...base, padding: 0, gap: 0 }),
            dropdownIndicator: (base) => ({ ...base, padding: '0 6px', color: 'inherit', display: 'flex', alignItems: 'center' }),
            multiValue: () => ({ display: 'none' }),
            multiValueLabel: () => ({ display: 'none' }),
            multiValueRemove: () => ({ display: 'none' }),
            indicatorSeparator: () => ({ display: 'none' }),
            input: (base) => ({ ...base, margin: 0, padding: 0, minWidth: 0, width: '100%' }),
            menu: (base) => ({ ...base, maxHeight: 200, overflow: 'hidden' }),
            menuList: (base) => ({ ...base, maxHeight: 155, paddingTop: 2, paddingBottom: 2 }),
        }
    }, [appliedTagIds.length])

    const tagFilterStyleMulti = useMemo(() => ({
        ...tagFilterStyle,
        control: (base) => ({
            ...tagFilterStyle.control(base),
            minHeight: '44px',
            height: '44px',
        }),
        valueContainer: (base) => ({
            ...tagFilterStyle.valueContainer(base),
            paddingTop: 0,
            paddingBottom: 0,
        }),
        option: (base) => ({
            ...base,
            paddingTop: 4,
            paddingBottom: 4,
            fontSize: '0.875rem',
            lineHeight: 1.2,
        }),
    }), [tagFilterStyle])

    const isMobileDevice = isMobile()

    return (
        <>
            {
                addTicketFromCameras &&
                <p className="mb-4">
                    <span className="font-semibold text-gray-900 dark:text-gray-100">{deviceForTicket.location} </span>
                    {secondsForTicket > 0 && <>
                        {t('in_minute')} <span className="font-semibold text-gray-900 dark:text-gray-100">{secondsToMinutes(secondsForTicket)}</span>
                    </>
                    }
                </p>
            }

            <Formik
                    initialValues={initialValuesForm}
                    validationSchema={validationSchema}
                    validate={validarPreguntasVisibles}
                    onSubmit={(values, { resetForm, setSubmitting, }) => {
                        onSubmit(values, setSubmitting, resetForm)
                    }}
                    innerRef={formikRef}
                >
                    {({ touched, errors, values, resetForm }) => {
                        // Se resuelve en cada render: una respuesta que abre o cierra una
                        // rama tiene que reflejarse en el acto.
                        const { visibles: preguntasVisibles, meta: nestingPreguntas } =
                            resolverVisibles(preguntasDelGrupo, values)
                        // Solo las preguntas que estaban a la vista en el ultimo intento de
                        // envio muestran su error. No se usa `touched` como el resto del form
                        // porque los QuestionType* no llaman `setFieldTouched`.
                        const errorDePregunta = (id) => (idsExigidos.has(claveDeId(id)) ? errors[id] : undefined)
                        return (
                            <Form id="add-ticket-form" className="relative">
                                <SubmittingWatcher onSubmittingChange={onSubmittingChange} />
                                <PreguntasExigidasWatcher
                                    preguntas={preguntasDelGrupo}
                                    onExigidasChange={setIdsExigidos}
                                />
                                <ScrollToError customErrorTargets={customErrorTargets} />
                                <DirtyWatcher onDirtyChange={onDirtyChange} externalDirty={hasExternalChanges} />
                                <div className="pb-6">
                                    <FormContainer>

                                <div className="mb-4 mt-4">
                                    <FormItem >
                                        <Field name="operator_id">
                                            {({ field, form }) => (
                                                <Radio.Group
                                                    value={multiTicktes ? "multiple" : "single"}
                                                    onChange={value => {
                                                        const isMultiple = value === "multiple"
                                                        onCheckIsMultiple(isMultiple)
                                                        form.setFieldValue("operator_id", "")
                                                        form.setFieldValue("store_id", "")
                                                        form.setFieldValue("parent_category", "")
                                                        form.setFieldValue("ticket_category_id", "")
                                                        form.setFieldTouched("operator_id", false)
                                                        form.setFieldTouched("store_id", false)
                                                        form.setFieldTouched("parent_category", false)
                                                        form.setFieldTouched("ticket_category_id", false)
                                                        setUsersMultipleTicktesId("")
                                                        setMultiStoresState(prev => ({ ...prev, baseItems: [], filteredItems: [], hasResponsible: '' }))
                                                        setMultiStores([])
                                                        setCheckedAllStores(false)
                                                        setShowCategoryFields(false)
                                                        setShowStoreFields(false)
                                                        setQuestionGroup(null)
                                                    }}
                                                >
                                                    <Radio value="single">{`A una ${t("store_alias").toLowerCase()}`}</Radio>
                                                    <Radio value="multiple">{`A varias ${t("stores_alias").toLowerCase()}`}</Radio>
                                                </Radio.Group>
                                            )}
                                        </Field>
                                    </FormItem>
                                </div>

                                {
                                    multiTicktes ?
                                        <>
                                            <FormItem
                                                label={t('assign_to')}
                                                asterisk
                                                invalid={errors.operator_id && touched.operator_id}
                                                errorMessage={errors.operator_id}
                                                data-error-field="operator_id"
                                            >
                                                <Field name="operator_id">
                                                    {({ field, form }) => (
                                                        <Select
                                                            isDisabled={loadingTeams}
                                                            isLoading={loadingTeams}
                                                            value={values.operator_id}
                                                            placeholder={t('assign_to')}
                                                            options={operatorGroupedOptions}
                                                            components={{
                                                                Option: CustomSelectOption,
                                                                Control: CustomControl
                                                            }}
                                                            onChange={async (selected) => {
                                                                form.setFieldValue(field.name, selected)
                                                                form.setFieldValue("store_id", "")
                                                                setMultiStores([])
                                                                setCheckedAllStores(false)
                                                                setSearchResults([])
                                                                if (searchInput.current) {
                                                                    searchInput.current.value = ''
                                                                }

                                                                const isResponsible = isResponsibleOption(selected)
                                                                onResponsibleChange?.(isResponsible)
                                                                setMultiStoresState(prev => ({
                                                                    ...prev,
                                                                    baseItems: [],
                                                                    filteredItems: [],
                                                                    hasResponsible: isResponsible ? selected.value : '',
                                                                }))

                                                                setLoadingTeams(true)
                                                                try {
                                                                    if (isResponsible) {
                                                                        setUsersMultipleTicktesId("")
                                                                        setDataUsersAndStores([])
                                                                        await fetchLocalTicketStores({ context: 'multi', page: 1, tags: storeFilters?.tags ?? [], hasResponsible: selected.value })
                                                                    } else {
                                                                        setUsersMultipleTicktesId(selected.id)
                                                                        const res = await apiGetUserStores(selected.id)
                                                                        setDataUsersAndStores(res.data.data)
                                                                    }
                                                                } catch (error) {
                                                                    console.error('Error fetching stores', error)
                                                                    if (!isResponsible) {
                                                                        toast.push(
                                                                            <Notification title={t('error')} type="danger" duration={4000}>
                                                                                {t('fetchStoresError', { defaultValue: 'No se pudieron cargar las tiendas del usuario.' })}
                                                                            </Notification>
                                                                        )
                                                                    }
                                                                } finally {
                                                                    setLoadingTeams(false)
                                                                }
                                                            }}
                                                        ></Select>
                                                    )}
                                                </Field>
                                            </FormItem>
                                            {showStoreFields && (
                                                <div ref={multiStoreSectionRef}>
                                                    <FormItem
                                                        label={t('stores_alias')}
                                                        asterisk
                                                        invalid={errors.store_id && touched.store_id}
                                                        data-error-field="store_id"
                                                    >
                                                        <Field name="store_id" >
                                                            {({ field, form }) => (
                                                                <>
                                                                    <div className="flex flex-col gap-3 md:flex-row md:items-start mb-3">
                                                                        {canRenderStoreTags && (
                                                                            <div className={`w-full md:w-auto flex-shrink-0 transition-all duration-200 ease-out ${filterWidthClass}`}>
                                                                            <div ref={tagFilterContainerRef} className={`rounded-full relative transition-colors ${appliedTagIds.length > 0
                                                                                ? 'bg-blue-500/20 dark:bg-blue-500/20 border border-blue-400 dark:border-blue-300 ring-1 ring-blue-400/50 dark:ring-blue-300/60 hover:bg-blue-500/25 dark:hover:bg-blue-500/25'
                                                                                : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
                                                                            }`}>
                                                                                    <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center gap-2 text-gray-600 dark:text-gray-100">
                                                                                        <HiOutlineFilter className="text-base flex-shrink-0" aria-hidden="true" />
                                                                                        {!tagFilterHasFocus && (
                                                                                            <span className="flex items-center gap-2 min-w-0 whitespace-nowrap">
                                                                                                {filterLabelContent}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                    <StoreTagFilter
                                                                                        tags={storeTags}
                                                                                        value={tempSelectedTags}
                                                                                        onChange={handleTagFilterChange}
                                                                                        onFocus={handleTagFilterFocus}
                                                                                        onBlur={handleTagFilterBlur}
                                                                                        onMenuOpen={handleTagFilterFocus}
                                                                                        onMenuClose={handleTagMenuClose}
                                                                                        onMenuApply={handleTagMenuApply}
                                                                                        onMenuCancel={handleTagFilterCancel}
                                                                                        isLoading={storeTagsLoading}
                                                                                        isDisabled={disableStoreControls}
                                                                                        menuMaxHeight={140}
                                                                                        size="md"
                                                                                        placeholder=" "
                                                                                        menuPlacement="auto"
                                                                                        autoApplyOnMenuClose={false}
                                                                                        hideSelectedValues={true}
                                                                                        disableClearButton={true}
                                                                                        backspaceRemovesValue={false}
                                                                                        className="rounded-full text-gray-600 dark:text-gray-100"
                                                                                        menuFooter={({ apply, cancel }) => (
                                                                                            <div className="flex gap-2">
                                                                                                <Button
                                                                                                    size="xs"
                                                                                                    variant="solid"
                                                                                                    onClick={(event) => {
                                                                                                        event.preventDefault()
                                                                                                        event.stopPropagation()
                                                                                                        apply()
                                                                                                    }}
                                                                                                    className="flex-1"
                                                                                                >
                                                                                                    {t('apply', { defaultValue: 'Aplicar' })}
                                                                                                </Button>
                                                                                                <Button
                                                                                                    size="xs"
                                                                                                    variant="plain"
                                                                                                    onClick={(event) => {
                                                                                                        event.preventDefault()
                                                                                                        event.stopPropagation()
                                                                                                        cancel()
                                                                                                    }}
                                                                                                    className="flex-1"
                                                                                                >
                                                                                                    {t('close', { defaultValue: 'Cerrar' })}
                                                                                                </Button>
                                                                                            </div>
                                                                                        )}
                                                                                        style={tagFilterStyleMulti}
                                                                                    />
                                                                                    {appliedTagIds.length > 0 && (
                                                                                        <button
                                                                                            type="button"
                                                                                            onMouseDown={(event) => {
                                                                                                event.preventDefault()
                                                                                                event.stopPropagation()
                                                                                            }}
                                                                                            onClick={(event) => {
                                                                                                event.preventDefault()
                                                                                                event.stopPropagation()
                                                                                                handleClearAppliedTags()
                                                                                            }}
                                                                                            className="absolute inset-y-0 right-7 flex items-center justify-center px-0.5 text-gray-600 dark:text-gray-200 hover:text-blue-600 dark:hover:text-blue-300 transition-colors z-10"
                                                                                            aria-label={t('clear')}
                                                                                        >
                                                                                            <HiX className="text-sm" />
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        <div className="flex-1">
                                                                            <Input
                                                                                ref={searchInput}
                                                                                className="w-full"
                                                                                size="md"
                                                                                disabled={multiStoresState.pagination?.loading || loadingTeams}
                                                                                placeholder={`${t('search', { defaultValue: 'Buscar' })} ${t('stores_alias').toLowerCase()}`}
                                                                                prefix={<HiOutlineSearch className="text-lg" />}
                                                                                onChange={onSearch}
                                                                                invalid={errors.store_id && touched.store_id}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    {hasAppliedTags && (
                                                                        <div className="flex flex-wrap items-center gap-2 mb-3">
                                                                            {selectedTagObjects.map(tag => (
                                                                                <span
                                                                                    key={tag.id}
                                                                                    className="inline-flex items-center gap-2 bg-blue-500/10 dark:bg-blue-400/10 text-blue-700 dark:text-blue-300 rounded-full px-3 py-1 text-sm font-medium border border-blue-400/30 dark:border-blue-300/30"
                                                                                >
                                                                                    {tag.name}
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => handleRemoveAppliedTag(tag.id)}
                                                                                        className="hover:bg-blue-500/20 dark:hover:bg-blue-400/20 rounded-full p-0.5 transition-colors"
                                                                                        aria-label={`Remove ${tag.name}`}
                                                                                    >
                                                                                        <HiX className="text-sm" />
                                                                                    </button>
                                                                                </span>
                                                                            ))}
                                                                            <button
                                                                                type="button"
                                                                                onClick={handleClearAppliedTags}
                                                                                className="text-sm text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-medium underline"
                                                                            >
                                                                                {t('clear')} {t('all_a_capitalize').toLowerCase()}
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                    {errors.store_id && touched.store_id && (
                                                                        <div className="form-explain" style={{ position: 'relative', marginTop: 3, marginBottom: 8 }}>
                                                                            {errors.store_id}
                                                                        </div>
                                                                    )}
                                                                    <div className="rounded-lg border border-gray-200 dark:border-gray-600">
                                                                        {multiStoresState.filteredItems.length > 0 && (
                                                                            <div className="px-3 py-2 border-b border-gray-200 dark:border-gray-600 flex justify-between items-center">
                                                                                <Checkbox
                                                                                    disabled={multiStoresState.pagination?.loading || loadingTeams}
                                                                                    className="cursor-pointer"
                                                                                    onClick={() => selectAllStores(!checkedAllStores)}
                                                                                    checked={checkedAllStores}
                                                                                    onChange={store => {
                                                                                        form.setFieldValue("store_id", store);
                                                                                    }}>
                                                                                    <span className='font-semibold text-sm'>Seleccionar todas</span>
                                                                                </Checkbox>
                                                                                <span className='text-sm text-gray-600 dark:text-gray-400'>{visibleSelectedCount}/{visibleTotalCount} seleccionadas</span>
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            ref={storeListRef}
                                                                            className="overflow-y-auto pr-1"
                                                                            style={{ maxHeight: storeListMaxHeight ?? STORE_LIST_MAX_HEIGHT }}
                                                                            onScroll={handleMultiStoreScroll}
                                                                            onMouseLeave={handleStoreListMouseLeave}
                                                                        >
                                                                            {(() => {
                                                                                const storesToShow = searchResults.length > 0 ? searchResults : multiStoresState.filteredItems
                                                                                const hasActiveSearch = searchInput.current?.value && searchInput.current.value.trim() !== ''
                                                                                const isLoading = multiStoresState.pagination?.loading
                                                                                const hasStores = storesToShow.length > 0

                                                                                // Carga inicial sin tiendas: solo spinner
                                                                                if (isLoading && !hasStores) {
                                                                                    return (
                                                                                        <div className="flex flex-col items-center gap-2 py-4 text-sm text-gray-500 dark:text-gray-300">
                                                                                            <Spinner size="sm" />
                                                                                            <span>
                                                                                                {t('searching_stores', {
                                                                                                    defaultValue: `Buscando ${multiTicktes ? t('stores_alias').toLowerCase() : t('store_alias').toLowerCase()}...`
                                                                                                })}
                                                                                            </span>
                                                                                        </div>
                                                                                    )
                                                                                }

                                                                                // Búsqueda activa sin resultados
                                                                                if (hasActiveSearch && searchResults.length === 0 && multiStoresState.filteredItems.length > 0) {
                                                                                    return (
                                                                                        <div className="px-3 py-4 text-sm text-gray-500 dark:text-gray-300">
                                                                                            No se encontraron {t('stores_alias').toLowerCase()} que coincidan con la búsqueda.
                                                                                        </div>
                                                                                    )
                                                                                }

                                                                                // Tiendas + spinner al final si está cargando más
                                                                                if (hasStores) {
                                                                                    return (
                                                                                        <>
                                                                                            {storesToShow.map((store, index) => (
                                                                                                <div
                                                                                                    key={store.id}
                                                                                                    className={`px-3 py-1.5 transition-colors ${
                                                                                                        store.checked
                                                                                                            ? 'bg-indigo-50 dark:bg-indigo-900/30'
                                                                                                            : 'hover:bg-gray-50 dark:hover:bg-gray-700/50'
                                                                                                    }`}
                                                                                                >
                                                                                                    <Checkbox
                                                                                                        disabled={loadingTeams}
                                                                                                        className="cursor-pointer"
                                                                                                        onClick={(event) => handleStoreCheckbox(event, store, index, storesToShow)}
                                                                                                        checked={store.checked}
                                                                                                        onChange={() => {
                                                                                                            form.setFieldValue("store_id", store);
                                                                                                        }}
                                                                                                    >
                                                                                                        {store.label}
                                                                                                    </Checkbox>
                                                                                                </div>
                                                                                            ))}
                                                                                            {isLoading && (
                                                                                                <div className="flex items-center justify-center gap-2 py-3 text-sm text-gray-400">
                                                                                                    <Spinner size="sm" />
                                                                                                </div>
                                                                                            )}
                                                                                        </>
                                                                                    )
                                                                                }

                                                                                // Sin tiendas
                                                                                return (
                                                                                    <div className="px-3 py-4 text-sm text-gray-500 dark:text-gray-300">
                                                                                        {!values.operator_id
                                                                                            ? `Selecciona un operador para ver las ${t('stores_alias').toLowerCase()}`
                                                                                            : `No hay ${t('stores_alias').toLowerCase()} que coincidan con las etiquetas seleccionadas.`
                                                                                        }
                                                                                    </div>
                                                                                )
                                                                            })()}
                                                                        </div>
                                                                    </div>

                                                                    {multiStores.length > 0 && (
                                                                        <div ref={selectedSummaryRef} className="mt-3">
                                                                            <SelectedStoresSummary
                                                                                stores={multiStores}
                                                                                onRemove={selectedStores}
                                                                                onClear={() => selectAllStores(false)}
                                                                            />
                                                                        </div>
                                                                    )}

                                                                </>
                                                            )}
                                                        </Field>
                                                    </FormItem>
                                                </div>
                                            )
                                            }
                                        </> :
                                        <>
                                            <FormItem
                                                label={t('store_alias')}
                                                asterisk
                                                invalid={errors.store_id && touched.store_id}
                                                errorMessage={errors.store_id}
                                                data-error-field="store_id"
                                            >
                                                <Field name="store_id">
                                                    {({ field, form }) => (
                                                        <>
                                                            <div className="flex flex-col gap-3 md:flex-row md:items-start mb-3">
                                                                {canRenderStoreTags && (
                                                                    <div className={`w-full md:w-auto flex-shrink-0 transition-all duration-200 ease-out ${filterWidthClass}`}>
                                                                        <div ref={tagFilterContainerRef} className={`rounded-full relative transition-colors ${appliedTagIds.length > 0
                                                                            ? 'bg-blue-500/20 dark:bg-blue-500/20 border border-blue-400 dark:border-blue-300 ring-1 ring-blue-400/50 dark:ring-blue-300/60 hover:bg-blue-500/25 dark:hover:bg-blue-500/25'
                                                                            : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
                                                                        }`}>
                                                                            <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center gap-2 text-gray-600 dark:text-gray-100">
                                                                                <HiOutlineFilter className="text-base flex-shrink-0" aria-hidden="true" />
                                                                                {!tagFilterHasFocus && (
                                                                                    <span className="flex items-center gap-2 min-w-0 whitespace-nowrap">
                                                                                        {filterLabelContent}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            <StoreTagFilter
                                                                                tags={storeTags}
                                                                                value={tempSelectedTags}
                                                                                onChange={handleTagFilterChange}
                                                                                onFocus={handleTagFilterFocus}
                                                                                onBlur={handleTagFilterBlur}
                                                                                onMenuOpen={handleTagFilterFocus}
                                                                                onMenuClose={handleTagMenuClose}
                                                                                onMenuApply={handleTagMenuApply}
                                                                                onMenuCancel={handleTagFilterCancel}
                                                                                isLoading={storeTagsLoading}
                                                                                isDisabled={disableStoreControls}
                                                                                menuMaxHeight={140}
                                                                                size="md"
                                                                                placeholder=" "
                                                                                menuPlacement="auto"
                                                                                autoApplyOnMenuClose={false}
                                                                                hideSelectedValues={true}
                                                                                disableClearButton={true}
                                                                                backspaceRemovesValue={false}
                                                                                className="rounded-full text-gray-600 dark:text-gray-100"
                                                                                menuFooter={({ apply, cancel }) => (
                                                                                    <div className="flex gap-2">
                                                                                        <Button
                                                                                            size="xs"
                                                                                            variant="solid"
                                                                                            onClick={(event) => {
                                                                                                event.preventDefault()
                                                                                                event.stopPropagation()
                                                                                                apply()
                                                                                            }}
                                                                                            className="flex-1"
                                                                                        >
                                                                                            {t('apply', { defaultValue: 'Aplicar' })}
                                                                                        </Button>
                                                                                        <Button
                                                                                            size="xs"
                                                                                            variant="plain"
                                                                                            onClick={(event) => {
                                                                                                event.preventDefault()
                                                                                                event.stopPropagation()
                                                                                                cancel()
                                                                                            }}
                                                                                            className="flex-1"
                                                                                        >
                                                                                            {t('close', { defaultValue: 'Cerrar' })}
                                                                                        </Button>
                                                                                    </div>
                                                                                )}
                                                                                style={tagFilterStyle}
                                                                            />
                                                                            {appliedTagIds.length > 0 && (
                                                                                <button
                                                                                    type="button"
                                                                                    onMouseDown={(event) => {
                                                                                        event.preventDefault()
                                                                                        event.stopPropagation()
                                                                                    }}
                                                                                    onClick={(event) => {
                                                                                        event.preventDefault()
                                                                                        event.stopPropagation()
                                                                                        handleClearAppliedTags()
                                                                                    }}
                                                                                    className="absolute inset-y-0 right-7 flex items-center justify-center px-0.5 text-gray-600 dark:text-gray-200 hover:text-blue-600 dark:hover:text-blue-300 transition-colors z-10"
                                                                                    aria-label={t('clear')}
                                                                                >
                                                                                    <HiX className="text-sm" />
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <div className="flex-1">
                                                                    <Select
                                                                        isDisabled={disableStoreControls}
                                                                        isClearable={true}
                                                                        value={values.store_id}
                                                                                placeholder={singleStoreInitialLoading
                                                                                    ? t('loading_stores', { defaultValue: `Cargando ${t('stores_alias', { defaultValue: 'tiendas' }).toLowerCase()}...` })
                                                                                    : `${t('select_or_search_one', { defaultValue: 'Seleccione o busque una' })} ${t('store_alias').toLowerCase()}`
                                                                                }
                                                                        options={(() => {
                                                                            // Asegurar que el valor seleccionado siempre esté en las opciones
                                                                            const currentValue = values.store_id
                                                                            if (currentValue && currentValue.id) {
                                                                                const isValueInOptions = stores.some(opt =>
                                                                                    (opt.id === currentValue.id) ||
                                                                                    (opt.value === currentValue.id)
                                                                                )
                                                                                if (!isValueInOptions) {
                                                                                    return [currentValue, ...stores]
                                                                                }
                                                                            }
                                                                            return stores
                                                                        })()}
                                                                        isLoading={loadingGlobalTicket || isSearching || (singleStoresState.pagination?.loading && stores.length === 0)}
                                                                        isLoadingMore={singleStoresState.pagination?.loading && singleStoresState.pagination?.hasMore && stores.length > 0}
                                                                        loadingMessage={() => t('loading_stores', { defaultValue: `Cargando ${t('stores_alias', { defaultValue: 'tiendas' }).toLowerCase()}...` })}
                                                                        onChange={store => {
                                                                            if (store === null) {
                                                                                handleStoreClear()
                                                                                form.setFieldValue(field.name, "")
                                                                                form.setFieldValue('operator_id', "")
                                                                                form.setFieldTouched('operator_id', false)
                                                                            } else {
                                                                                form.setFieldValue(field.name, store)
                                                                                form.setFieldValue('operator_id', "")
                                                                                form.setFieldTouched('operator_id', false)
                                                                                getStoreUsers(store.id)
                                                                                getTicketCategoriExpiration({ store_id: store.id, ticket_category_id: form.values?.ticket_category_id?.id })
                                                                            }
                                                                            onResponsibleChange?.(false)
                                                                        }}
                                                                        onMenuOpen={handleStoreMenuOpen}
                                                                        onMenuClose={handleStoreMenuClose}
                                                                        onMenuScrollToBottom={handleLoadMoreStores}
                                                                        onInputChange={handleStoreInputChange}
                                                                        filterOption={null}
                                                                        menuPlacement="auto"
                                                                        blurInputOnSelect={true}
                                                                        components={{
                                                                            MenuList: CustomMenuList
                                                                        }}
                                                                        noOptionsMessage={() => {
                                                                            if (singleStoresState.pagination?.loading && stores.length === 0) {
                                                                                const alias = t('stores_alias', { defaultValue: 'tiendas' })
                                                                                return (
                                                                                    <div className="flex flex-col items-center gap-2 py-4">
                                                                                        <Spinner size="sm" />
                                                                                        <span>{t('loading_stores', { defaultValue: `Cargando ${alias.toLowerCase()}...` })}</span>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                            if (storeSearchInput) {
                                                                                return `No se encontraron ${t('stores_alias', { defaultValue: 'tiendas' }).toLowerCase()}`
                                                                            }
                                                                            if (singleStoresState.filters?.tags?.length) {
                                                                                return t('no_stores_for_filters', { defaultValue: 'No se encontraron tiendas con los filtros aplicados' })
                                                                            }
                                                                            return t('type_to_search', { defaultValue: 'Escribe para buscar' })
                                                                        }}
                                                                    ></Select>
                                                                </div>
                                                            </div>
                                                            {hasAppliedTags && (
                                                                <div className="flex flex-wrap items-center gap-2 mb-3">
                                                                    {selectedTagObjects.map(tag => (
                                                                        <span
                                                                            key={tag.id}
                                                                            className="inline-flex items-center gap-2 bg-blue-500/10 dark:bg-blue-400/10 text-blue-700 dark:text-blue-300 rounded-full px-3 py-1 text-sm font-medium border border-blue-400/30 dark:border-blue-300/30"
                                                                        >
                                                                            {tag.name}
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => handleRemoveAppliedTag(tag.id)}
                                                                                className="hover:bg-blue-500/20 dark:hover:bg-blue-400/20 rounded-full p-0.5 transition-colors"
                                                                                aria-label={`Remove ${tag.name}`}
                                                                            >
                                                                                <HiX className="text-sm" />
                                                                            </button>
                                                                        </span>
                                                                    ))}
                                                                    <button
                                                                        type="button"
                                                                        onClick={handleClearAppliedTags}
                                                                        className="text-sm text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-medium underline"
                                                                    >
                                                                        {t('clear')} {t('all_a_capitalize').toLowerCase()}
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </Field>
                                            </FormItem>

                                            {values.store_id &&
                                                <FormItem
                                                    label={t('assign_to')}
                                                    asterisk
                                                    invalid={errors.operator_id && touched.operator_id}
                                                    data-error-field="operator_id"
                                                >
                                                    <Field name="operator_id">
                                                        {({ field, form }) => (
                                                            <>
                                                                <Select
                                                                    value={values.operator_id}
                                                                    placeholder={t('assign_to')}
                                                                    options={singleOperatorGroupedOptions}
                                                                    className="mb-2"
                                                                    isLoading={loadingStores}
                                                                    components={{
                                                                        Option: CustomSelectOption,
                                                                        Control: CustomControl
                                                                    }}
                                                                    onChange={selected => {
                                                                        form.setFieldValue(field.name, selected)
                                                                        setShowCategoryFields(true)
                                                                        onResponsibleChange?.(isResponsibleOption(selected))
                                                                    }}
                                                                ></Select>
                                                                {errors.operator_id && touched.operator_id && (
                                                                    <div className="form-explain" style={{ position: 'relative', marginTop: 3, marginBottom: 8 }}>
                                                                        {errors.operator_id}
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </Field>
                                                </FormItem>
                                            }
                                        </>

                                }

                                {
                                    showCategoryFields &&
                                    <>
                                        <FormItem
                                            label={t('category')}
                                            asterisk
                                            invalid={errors.parent_category && touched.parent_category}
                                            errorMessage={errors.parent_category}
                                            data-error-field="parent_category"
                                        >
                                        <Field name="parent_category">
                                            {({ field, form }) => (
                                                <Select
                                                    field={field}
                                                    value={values.parent_category}
                                                    form={form}
                                                    placeholder={t('selectCategory')}
                                                    options={ticketParentCategories}
                                                    isLoading={loadingGlobalTicket}
                                                    isDisabled={multiTicktes && loadingTeams}
                                                    onChange={parentId => {
                                                        setCategoryTicket(parentId.id)
                                                        form.setFieldValue(field.name, parentId)
                                                        form.setFieldValue('ticket_category_id', "")
                                                        form.setFieldTouched('ticket_category_id', false)
                                                    }}
                                                    autoFocus={false}
                                                    openMenuOnFocus={false}
                                                >
                                                </Select>
                                            )}
                                        </Field>
                                    </FormItem>
                                        <FormItem
                                            label={t('subCategory')}
                                            asterisk
                                            invalid={errors.ticket_category_id && touched.ticket_category_id}
                                            errorMessage={errors.ticket_category_id}
                                            data-error-field="ticket_category_id"
                                        >
                                        <Field name="ticket_category_id">
                                            {({ field, form }) => (
                                                <Select
                                                    value={values.ticket_category_id}
                                                    placeholder={t('selectSubCategory')}
                                                    options={categoriesOptions}
                                                    isDisabled={multiTicktes && loadingTeams}
                                                    onChange={category => {
                                                        form.setFieldValue(field.name, category)
                                                        setTicketCategoryById(category.id)
                                                        getTicketCategoriExpiration({ store_id: form.values.store_id.id, ticket_category_id: category.id })
                                                    }}
                                                    components={{
                                                        Option: CustomSelectOptionSubcategory,
                                                        Control: CustomControlSubcategory
                                                    }}
                                                    autoFocus={false}
                                                    openMenuOnFocus={false}
                                                ></Select>
                                            )}
                                        </Field>
                                    </FormItem>
                                    </>
                                }
                                {values.ticket_category_id && search_expiration_date &&
                                    <FormItem
                                        label={t('expires')}
                                    >
                                        {loadingTicketExpiration
                                            ? <div><Spinner /></div>
                                            : <Field>
                                                {({ field, form }) => (
                                                    <DateTimepicker
                                                        locale="es"
                                                        value={ticketExpiredAt && new Date(ticketExpiredAt)}
                                                        loading={true}
                                                        minDate={new Date()}
                                                        amPm={false}
                                                        inputSize="sm"
                                                        onChange={expired_at => {
                                                            setTicketExpiredAt(expired_at ? new Date(expired_at) : null)
                                                        }}
                                                    />
                                                )}
                                            </Field>
                                        }
                                    </FormItem>
                                }
                                {
                                    questionLoading && questionGroup &&
                                    <QuestionnaireWrapper
                                        name={questionGroup?.name}
                                        questions={preguntasVisibles}
                                        nesting={nestingPreguntas}
                                        nestingMode="fija"
                                        className="mb-4"
                                        renderQuestion={(question) => (
                                            // El texto del error lo pone `AnswerField` dentro de cada
                                            // QuestionType*: aca solo va `invalid`, o el mensaje sale dos veces.
                                            <FormItem
                                                key={question.id}
                                                invalid={Boolean(errorDePregunta(question.id))}
                                            >
                                                <Field name={question.id}>
                                                    {({ field, form }) => (
                                                        <QuestionGenerator
                                                            onChange={(val, type) => {
                                                                // Antes de escribir el valor nuevo: si este cambio
                                                                // cierra una rama, borra sus respuestas de Formik y
                                                                // del localStorage del que se arma el payload.
                                                                limpiarRamaOculta(form, values, question.id, val)
                                                                let updatedAnswers = { ...answers };
                                                                if ([TEXT, SELECTOR, RADIO, MENU, TEXTAREA, DATE].includes(question.question_type_id)) {
                                                                    updatedAnswers[question.id] = val;
                                                                }
                                                                if (question.question_type_id === CHECKBOX) {
                                                                    updatedAnswers[question.id] = val ? JSON.parse(val) : val;
                                                                }
                                                                setAnswer(updatedAnswers);

                                                                if (![FILE, AI_VISUAL_CHECK].includes(question.question_type_id) && field.value === val) {
                                                                    form.setFieldValue(field.name, '');
                                                                } else if ([FILE, AI_VISUAL_CHECK].includes(question.question_type_id)) {
                                                                    const valueFiles = setFilesValues(question.id, val, type)
                                                                    form.setFieldValue(field.name, valueFiles);
                                                                } else {
                                                                    form.setFieldValue(field.name, val);
                                                                }
                                                                saveFormInLocalStorage({ question: question.id, type: question.question_type_id, value: val })
                                                            }}
                                                            questions={question}
                                                            createAnswers={createAnswers}
                                                            errorMessage={errorDePregunta(question.id)}
                                                            onUploadFilesQuestion={onUploadFilesQuestion}
                                                            removeFileState={removeFileState}
                                                        />
                                                    )}
                                                </Field>
                                            </FormItem>
                                        )}
                                    />
                                }
                                {
                                    values.ticket_category_id &&
                                    <>
                                        <FormItem
                                            className="mb-8"
                                            labelClass="!justify-start"
                                            label={t('description')}
                                            invalid={errors.description && touched.description}
                                            errorMessage={errors.description}

                                        >
                                            <Field
                                                name="description"
                                                placeholder={t('addDescription')}>
                                                {({ field, form }) => (
                                                    <RichTextEditor
                                                        value={values.description}
                                                        modules={modules}
                                                        onChange={val => {
                                                            form.setFieldValue(field.name, val)
                                                        }}

                                                    />
                                                )}
                                            </Field>
                                        </FormItem>

                                    </>
                                }
                                <FormItem className="mt-8">
                                    <Field name="file">
                                        {({ field, form }) => (
                                            <Upload
                                                onChange={files => onUpload(files, 'change_files')}
                                                draggable
                                                multiple
                                                uploadLimit={10}
                                                removeFileState={file => onUpload(file, 'remove_file')}
                                            >
                                                <div className="my-16 text-center">
                                                    <div className="text-4xl mb-4 flex justify-center">
                                                        <FcImageFile />
                                                    </div>
                                                    <p className="font-semibold">
                                                        <span className="text-gray-800 dark:text-white">{t('dragFile')}</span>
                                                    </p>
                                                </div>
                                            </Upload>
                                        )}
                                    </Field>
                                </FormItem>

                                    </FormContainer>
                                </div>

                            {ticket_schedule_can_store && showTicketScheduleForm && (
                                <div
                                    ref={scheduleSectionRef}
                                    className="mt-6 border-t border-gray-200 dark:border-gray-600 pt-6"
                                >
                                    <AddTicketSchedule
                                        errors={errors}
                                        touched={touched}
                                        values={values}
                                        defaultRecurrence={DEFAULT_RECURRENCE}
                                    />
                                </div>
                            )}

                        </Form>
                        )
                    }}
                </Formik>
        </>
    )

}

export default AddTicket
